//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import authService from '../components/api-authorization/AuthorizeService';
export class ApiClientBase {
    baseApiUrl: string = '';

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        const token = await authService.getAccessToken();
        options.headers = { ...options.headers, authorization: `Bearer ${token}` };
        return Promise.resolve(options);
    }

    protected transformResult(
        url: string,
        response: Response,
        processor: (response: Response) => any
    ) {
        if (response.status === 401) {
            const isAuthRoute = window.location.pathname.startsWith('/authentication');
            const isRecovering = sessionStorage.getItem(AUTH_RECOVERY_FLAG) === '1';

            console.warn(
                '[ApiClient] 401 Unauthorized — session/token rejected by API.',
                { url, statusText: response.statusText, isAuthRoute, isRecovering }
            );

            // Avoid infinite loops when already recovering or already on auth routes.
            if (isAuthRoute || isRecovering) {
                return processor(response);
            }

            // 2026-03-23: Mark this tab as "recovering" before auth redirect.
            sessionStorage.setItem(AUTH_RECOVERY_FLAG, '1');
            // 2026-03-23: Cleanup transient oidc-client state entries from interrupted flows.
            authService.clearStaleAuthState().catch((error: unknown) => {
                console.warn('[ApiClient] Failed to clear stale OIDC state before login redirect.', {
                    error,
                });
            });
            // 2026-03-23: Remove persisted user so next login starts cleanly.
            authService.userManager?.removeUser?.().catch((error: unknown) => {
                console.warn('[ApiClient] Failed to remove stale OIDC user before login redirect.', {
                    error,
                });
            });

            // 2026-03-23: Use login redirect instead of hard reload to avoid reload loops.
            // NOTE: Login.tsx validates returnUrl as a same-origin *absolute* URL.
            const returnUrl = `${window.location.origin}${window.location.pathname}${window.location.search}${window.location.hash}`;
            window.location.assign(`/authentication/login?returnUrl=${encodeURIComponent(returnUrl)}`);
            return new Promise(() => {});
        }

        // 2026-03-23: Recovery completed on non-auth routes, clear loop-prevention flag.
        if (!window.location.pathname.startsWith('/authentication')) {
            sessionStorage.removeItem(AUTH_RECOVERY_FLAG);
        }

        return processor(response);
    }

    protected getBaseUrl(defaultUrl: string, baseUrl?: string) {
        return this.baseApiUrl;
    }
}

export class ApiTokensClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(request: CreateApiTokenRequest): Promise<ApiTokenCreatedVm> {
        let url_ = this.baseUrl + "/api/ApiTokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ApiTokenCreatedVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApiTokenCreatedVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiTokenCreatedVm>(null as any);
    }

    getAll(): Promise<ApiTokenVm[]> {
        let url_ = this.baseUrl + "/api/ApiTokens";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ApiTokenVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTokenVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiTokenVm[]>(null as any);
    }

    revoke(id: number): Promise<ApiTokenVm> {
        let url_ = this.baseUrl + "/api/ApiTokens/{id}/revoke";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRevoke(_response));
        });
    }

    protected processRevoke(response: Response): Promise<ApiTokenVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTokenVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiTokenVm>(null as any);
    }
}

export class CategoriesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CategoryVm[]> {
        let url_ = this.baseUrl + "/api/Categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CategoryVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryVm[]>(null as any);
    }

    create(command: CreateCategoryCommandOfCategory): Promise<CategoryVm> {
        let url_ = this.baseUrl + "/api/Categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CategoryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CategoryVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryVm>(null as any);
    }

    getById(id: number): Promise<CategoryVm> {
        let url_ = this.baseUrl + "/api/Categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CategoryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryVm>(null as any);
    }

    update(id: number, command: UpdateCategoryCommandOfCategory): Promise<CategoryVm> {
        let url_ = this.baseUrl + "/api/Categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CategoryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CitiesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CityVm[]> {
        let url_ = this.baseUrl + "/api/Cities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CityVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm[]>(null as any);
    }

    create(command: CreateCityCommandOfCity): Promise<CityVm> {
        let url_ = this.baseUrl + "/api/Cities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CityVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm>(null as any);
    }

    getById(id: number): Promise<CityVm> {
        let url_ = this.baseUrl + "/api/Cities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm>(null as any);
    }

    update(id: number, command: UpdateCityCommandOfCity): Promise<CityVm> {
        let url_ = this.baseUrl + "/api/Cities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Cities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ClubCoachesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateClubCoachCommandOfClubCoach): Promise<ClubCoachVm> {
        let url_ = this.baseUrl + "/api/ClubCoaches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ClubCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ClubCoachVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubCoachVm>(null as any);
    }

    update(id: number, command: UpdateClubCoachCommandOfClubCoach): Promise<ClubCoachVm> {
        let url_ = this.baseUrl + "/api/ClubCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ClubCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubCoachVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubCoachVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ClubCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ClubPlayersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateClubPlayerCommandOfClubPlayer): Promise<ClubPlayerVm> {
        let url_ = this.baseUrl + "/api/ClubPlayers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ClubPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ClubPlayerVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubPlayerVm>(null as any);
    }

    update(id: number, command: UpdateClubPlayerCommandOfClubPlayer): Promise<ClubPlayerVm> {
        let url_ = this.baseUrl + "/api/ClubPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ClubPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubPlayerVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubPlayerVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ClubPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ClubsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<ClubVm[]> {
        let url_ = this.baseUrl + "/api/Clubs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ClubVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClubVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubVm[]>(null as any);
    }

    create(command: CreateClubCommandOfClub): Promise<ClubDetailVm> {
        let url_ = this.baseUrl + "/api/Clubs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ClubDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ClubDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubDetailVm>(null as any);
    }

    getPaginated(filter_NameUniversal: string | null | undefined, filter_ShortName: string | null | undefined, filter_ActiveFrom: Date | null | undefined, filter_ActiveTo: Date | null | undefined, filter_IsPro: boolean | null | undefined, filter_Federation: string | null | undefined, filter_Country: string | null | undefined, filter_City: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfClubVm> {
        let url_ = this.baseUrl + "/api/Clubs/search?";
        if (filter_NameUniversal !== undefined && filter_NameUniversal !== null)
            url_ += "Filter.NameUniversal=" + encodeURIComponent("" + filter_NameUniversal) + "&";
        if (filter_ShortName !== undefined && filter_ShortName !== null)
            url_ += "Filter.ShortName=" + encodeURIComponent("" + filter_ShortName) + "&";
        if (filter_ActiveFrom !== undefined && filter_ActiveFrom !== null)
            url_ += "Filter.ActiveFrom=" + encodeURIComponent(filter_ActiveFrom ? "" + filter_ActiveFrom.toISOString() : "") + "&";
        if (filter_ActiveTo !== undefined && filter_ActiveTo !== null)
            url_ += "Filter.ActiveTo=" + encodeURIComponent(filter_ActiveTo ? "" + filter_ActiveTo.toISOString() : "") + "&";
        if (filter_IsPro !== undefined && filter_IsPro !== null)
            url_ += "Filter.IsPro=" + encodeURIComponent("" + filter_IsPro) + "&";
        if (filter_Federation !== undefined && filter_Federation !== null)
            url_ += "Filter.Federation=" + encodeURIComponent("" + filter_Federation) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (filter_City !== undefined && filter_City !== null)
            url_ += "Filter.City=" + encodeURIComponent("" + filter_City) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfClubVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClubVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClubVm>(null as any);
    }

    getById(id: number): Promise<ClubDetailVm> {
        let url_ = this.baseUrl + "/api/Clubs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ClubDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubDetailVm>(null as any);
    }

    update(id: number, command: UpdateClubCommandOfClub): Promise<ClubDetailVm> {
        let url_ = this.baseUrl + "/api/Clubs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ClubDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Clubs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    removeClubFromFederation(id: number): Promise<ClubDetailVm> {
        let url_ = this.baseUrl + "/api/Clubs/{id}/remove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveClubFromFederation(_response));
        });
    }

    protected processRemoveClubFromFederation(response: Response): Promise<ClubDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubDetailVm>(null as any);
    }
}

export class CoachesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CoachVm[]> {
        let url_ = this.baseUrl + "/api/Coaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CoachVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoachVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoachVm[]>(null as any);
    }

    create(command: CreateCoachCommand): Promise<CoachDetailVm> {
        let url_ = this.baseUrl + "/api/Coaches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CoachDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CoachDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoachDetailVm>(null as any);
    }

    getPaginated(filter_Name: string | null | undefined, filter_Surname: string | null | undefined, filter_CountryOfBirth: string | null | undefined, filter_CityOfBirth: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfCoachVm> {
        let url_ = this.baseUrl + "/api/Coaches/search?";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Surname !== undefined && filter_Surname !== null)
            url_ += "Filter.Surname=" + encodeURIComponent("" + filter_Surname) + "&";
        if (filter_CountryOfBirth !== undefined && filter_CountryOfBirth !== null)
            url_ += "Filter.CountryOfBirth=" + encodeURIComponent("" + filter_CountryOfBirth) + "&";
        if (filter_CityOfBirth !== undefined && filter_CityOfBirth !== null)
            url_ += "Filter.CityOfBirth=" + encodeURIComponent("" + filter_CityOfBirth) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCoachVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCoachVm>(null as any);
    }

    getById(id: number): Promise<CoachDetailVm> {
        let url_ = this.baseUrl + "/api/Coaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CoachDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoachDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoachDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Coaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CompetitionsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CompetitionVm[]> {
        let url_ = this.baseUrl + "/api/Competitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CompetitionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompetitionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionVm[]>(null as any);
    }

    create(command: CreateCompetitionCommandOfCompetition): Promise<CompetitionDetailVm> {
        let url_ = this.baseUrl + "/api/Competitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CompetitionDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CompetitionDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionDetailVm>(null as any);
    }

    getPaginated(filter_NameUniversal: string | null | undefined, filter_StartDate: Date | null | undefined, filter_EndDate: Date | null | undefined, filter_IsPro: boolean | null | undefined, filter_Federation: string | null | undefined, filter_Category: string | null | undefined, filter_CompetitionType: string | null | undefined, filter_Country: string | null | undefined, filter_City: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfCompetitionVm> {
        let url_ = this.baseUrl + "/api/Competitions/search?";
        if (filter_NameUniversal !== undefined && filter_NameUniversal !== null)
            url_ += "Filter.NameUniversal=" + encodeURIComponent("" + filter_NameUniversal) + "&";
        if (filter_StartDate !== undefined && filter_StartDate !== null)
            url_ += "Filter.StartDate=" + encodeURIComponent(filter_StartDate ? "" + filter_StartDate.toISOString() : "") + "&";
        if (filter_EndDate !== undefined && filter_EndDate !== null)
            url_ += "Filter.EndDate=" + encodeURIComponent(filter_EndDate ? "" + filter_EndDate.toISOString() : "") + "&";
        if (filter_IsPro !== undefined && filter_IsPro !== null)
            url_ += "Filter.IsPro=" + encodeURIComponent("" + filter_IsPro) + "&";
        if (filter_Federation !== undefined && filter_Federation !== null)
            url_ += "Filter.Federation=" + encodeURIComponent("" + filter_Federation) + "&";
        if (filter_Category !== undefined && filter_Category !== null)
            url_ += "Filter.Category=" + encodeURIComponent("" + filter_Category) + "&";
        if (filter_CompetitionType !== undefined && filter_CompetitionType !== null)
            url_ += "Filter.CompetitionType=" + encodeURIComponent("" + filter_CompetitionType) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (filter_City !== undefined && filter_City !== null)
            url_ += "Filter.City=" + encodeURIComponent("" + filter_City) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfCompetitionVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCompetitionVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCompetitionVm>(null as any);
    }

    getById(id: number): Promise<CompetitionDetailVm> {
        let url_ = this.baseUrl + "/api/Competitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CompetitionDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionDetailVm>(null as any);
    }

    update(id: number, command: UpdateCompetitionCommandOfCompetition): Promise<CompetitionDetailVm> {
        let url_ = this.baseUrl + "/api/Competitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CompetitionDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Competitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getStandings(id: number): Promise<StandingsVm[]> {
        let url_ = this.baseUrl + "/api/Competitions/{id}/standings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStandings(_response));
        });
    }

    protected processGetStandings(response: Response): Promise<StandingsVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandingsVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandingsVm[]>(null as any);
    }

    updateStandings(id: number): Promise<StandingsVm[]> {
        let url_ = this.baseUrl + "/api/Competitions/{id}/standings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateStandings(_response));
        });
    }

    protected processUpdateStandings(response: Response): Promise<StandingsVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandingsVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandingsVm[]>(null as any);
    }
}

export class CompetitionTeamsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateCompetitionTeamCommand): Promise<CompetitionTeamVm> {
        let url_ = this.baseUrl + "/api/CompetitionTeams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CompetitionTeamVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CompetitionTeamVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTeamVm>(null as any);
    }

    update(id: number, command: UpdateCompetitionTeamCommandOfCompetitionTeam): Promise<CompetitionTeamVm> {
        let url_ = this.baseUrl + "/api/CompetitionTeams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CompetitionTeamVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionTeamVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTeamVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/CompetitionTeams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CompetitionTypesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CompetitionTypeVm[]> {
        let url_ = this.baseUrl + "/api/CompetitionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CompetitionTypeVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompetitionTypeVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTypeVm[]>(null as any);
    }

    create(command: CreateCompetitionTypeCommandOfCompetitionType): Promise<CompetitionTypeVm> {
        let url_ = this.baseUrl + "/api/CompetitionTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CompetitionTypeVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CompetitionTypeVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTypeVm>(null as any);
    }

    getById(id: number): Promise<CompetitionTypeVm> {
        let url_ = this.baseUrl + "/api/CompetitionTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CompetitionTypeVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionTypeVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTypeVm>(null as any);
    }

    update(id: number, command: UpdateCompetitionTypeCommandOfCompetitionType): Promise<CompetitionTypeVm> {
        let url_ = this.baseUrl + "/api/CompetitionTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CompetitionTypeVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionTypeVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTypeVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/CompetitionTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CountriesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CountryVm[]> {
        let url_ = this.baseUrl + "/api/Countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CountryVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryVm[]>(null as any);
    }

    create(command: CreateCountryCommandOfCountry): Promise<CountryDetailVm> {
        let url_ = this.baseUrl + "/api/Countries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CountryDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CountryDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailVm>(null as any);
    }

    getById(id: number): Promise<CountryDetailVm> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CountryDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailVm>(null as any);
    }

    update(id: number, command: UpdateCountryCommandOfCountry): Promise<CountryDetailVm> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CountryDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailVm>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EventsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getLightByMatchId(matchId: number): Promise<EventLightVm[]> {
        let url_ = this.baseUrl + "/api/Events/light/{matchId}";
        if (matchId === undefined || matchId === null)
            throw new Error("The parameter 'matchId' must be defined.");
        url_ = url_.replace("{matchId}", encodeURIComponent("" + matchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLightByMatchId(_response));
        });
    }

    protected processGetLightByMatchId(response: Response): Promise<EventLightVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventLightVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventLightVm[]>(null as any);
    }

    getByMatchId(matchId: number): Promise<EventVm[]> {
        let url_ = this.baseUrl + "/api/Events/{matchId}";
        if (matchId === undefined || matchId === null)
            throw new Error("The parameter 'matchId' must be defined.");
        url_ = url_.replace("{matchId}", encodeURIComponent("" + matchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByMatchId(_response));
        });
    }

    protected processGetByMatchId(response: Response): Promise<EventVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventVm[]>(null as any);
    }

    create(command: CreateEventCommand): Promise<EventVm> {
        let url_ = this.baseUrl + "/api/Events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<EventVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = EventVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventVm>(null as any);
    }

    update(id: number, command: UpdateEventCommand): Promise<EventVm> {
        let url_ = this.baseUrl + "/api/Events/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<EventVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventVm>(null as any);
    }

    delete(id: number): Promise<EventVm> {
        let url_ = this.baseUrl + "/api/Events/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<EventVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventVm>(null as any);
    }
}

export class FederationOfficialsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateFederationOfficialCommandOfFederationOfficial): Promise<FederationOfficialVm> {
        let url_ = this.baseUrl + "/api/FederationOfficials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<FederationOfficialVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FederationOfficialVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationOfficialVm>(null as any);
    }

    update(id: number, command: UpdateFederationOfficialCommand): Promise<FederationOfficialVm> {
        let url_ = this.baseUrl + "/api/FederationOfficials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FederationOfficialVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederationOfficialVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationOfficialVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/FederationOfficials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class FederationsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<FederationVm[]> {
        let url_ = this.baseUrl + "/api/Federations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<FederationVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FederationVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationVm[]>(null as any);
    }

    create(command: CreateFederationCommandOfFederation): Promise<FederationDetailVm> {
        let url_ = this.baseUrl + "/api/Federations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<FederationDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FederationDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationDetailVm>(null as any);
    }

    getPaginated(filter_NameUniversal: string | null | undefined, filter_ShortName: string | null | undefined, filter_ActiveFrom: Date | null | undefined, filter_ActiveTo: Date | null | undefined, filter_IsPro: boolean | null | undefined, filter_Country: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfFederationVm> {
        let url_ = this.baseUrl + "/api/Federations/search?";
        if (filter_NameUniversal !== undefined && filter_NameUniversal !== null)
            url_ += "Filter.NameUniversal=" + encodeURIComponent("" + filter_NameUniversal) + "&";
        if (filter_ShortName !== undefined && filter_ShortName !== null)
            url_ += "Filter.ShortName=" + encodeURIComponent("" + filter_ShortName) + "&";
        if (filter_ActiveFrom !== undefined && filter_ActiveFrom !== null)
            url_ += "Filter.ActiveFrom=" + encodeURIComponent(filter_ActiveFrom ? "" + filter_ActiveFrom.toISOString() : "") + "&";
        if (filter_ActiveTo !== undefined && filter_ActiveTo !== null)
            url_ += "Filter.ActiveTo=" + encodeURIComponent(filter_ActiveTo ? "" + filter_ActiveTo.toISOString() : "") + "&";
        if (filter_IsPro !== undefined && filter_IsPro !== null)
            url_ += "Filter.IsPro=" + encodeURIComponent("" + filter_IsPro) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfFederationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfFederationVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfFederationVm>(null as any);
    }

    getById(id: number): Promise<FederationDetailVm> {
        let url_ = this.baseUrl + "/api/Federations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<FederationDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederationDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationDetailVm>(null as any);
    }

    update(id: number, command: UpdateFederationCommand): Promise<FederationDetailVm> {
        let url_ = this.baseUrl + "/api/Federations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FederationDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederationDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Federations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class MatchCoachesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateMatchCoachCommandOfMatchCoach): Promise<MatchCoachVm> {
        let url_ = this.baseUrl + "/api/MatchCoaches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<MatchCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MatchCoachVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchCoachVm>(null as any);
    }

    update(id: number, command: UpdateMatchCoachCommandOfMatchCoach): Promise<MatchCoachVm> {
        let url_ = this.baseUrl + "/api/MatchCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<MatchCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchCoachVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchCoachVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/MatchCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class MatchesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<MatchVm[]> {
        let url_ = this.baseUrl + "/api/Matches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<MatchVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MatchVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchVm[]>(null as any);
    }

    create(command: CreateMatchCommandOfMatch): Promise<MatchDetailVm> {
        let url_ = this.baseUrl + "/api/Matches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<MatchDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MatchDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchDetailVm>(null as any);
    }

    getPaginated(paginationFilter: PaginationFilterOfMatchFilter): Promise<PaginatedListOfMatchVm> {
        let url_ = this.baseUrl + "/api/Matches/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paginationFilter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfMatchVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfMatchVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfMatchVm>(null as any);
    }

    getById(id: number): Promise<MatchDetailVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<MatchDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchDetailVm>(null as any);
    }

    update(id: number, command: UpdateMatchCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Matches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getLineupFromLastFinishedMatch(id: number): Promise<LatestFinishedMatchLineupVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}/lineup-from-last-finished-match";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLineupFromLastFinishedMatch(_response));
        });
    }

    protected processGetLineupFromLastFinishedMatch(response: Response): Promise<LatestFinishedMatchLineupVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LatestFinishedMatchLineupVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LatestFinishedMatchLineupVm>(null as any);
    }

    updateOfficials(id: number, command: CreateOrUpdateMatchOfficialsCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{id}/officials";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateOfficials(_response));
        });
    }

    protected processUpdateOfficials(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updatePlayers(id: number, command: CreateOrUpdateMatchPlayersCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{id}/players";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePlayers(_response));
        });
    }

    protected processUpdatePlayers(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateCoaches(id: number, command: CreateOrUpdateMatchCoachesCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{id}/coaches";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCoaches(_response));
        });
    }

    protected processUpdateCoaches(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateMatchLog(id: number, command: UpdateMatchLogCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{id}/log";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateMatchLog(_response));
        });
    }

    protected processUpdateMatchLog(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateDisciplinaryNote(id: number, command: UpdateMatchDisciplinaryNoteCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Matches/{id}/disciplinary-note";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDisciplinaryNote(_response));
        });
    }

    protected processUpdateDisciplinaryNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    confirmMatchLog(matchOfficialId: number, command: ConfirmMatchLogCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{matchOfficialId}/confirm";
        if (matchOfficialId === undefined || matchOfficialId === null)
            throw new Error("The parameter 'matchOfficialId' must be defined.");
        url_ = url_.replace("{matchOfficialId}", encodeURIComponent("" + matchOfficialId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmMatchLog(_response));
        });
    }

    protected processConfirmMatchLog(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class MatchOfficialsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateMatchOfficialCommandOfMatchOfficial): Promise<MatchOfficialVm> {
        let url_ = this.baseUrl + "/api/MatchOfficials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<MatchOfficialVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MatchOfficialVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchOfficialVm>(null as any);
    }

    update(id: number, command: UpdateMatchOfficialCommandOfMatchOfficial): Promise<MatchOfficialVm> {
        let url_ = this.baseUrl + "/api/MatchOfficials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<MatchOfficialVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchOfficialVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchOfficialVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/MatchOfficials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class MatchPlayersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateMatchPlayerCommandOfMatchPlayer): Promise<MatchPlayerVm> {
        let url_ = this.baseUrl + "/api/MatchPlayers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<MatchPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MatchPlayerVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchPlayerVm>(null as any);
    }

    update(id: number, command: UpdateMatchPlayerCommandOfMatchPlayer): Promise<MatchPlayerVm> {
        let url_ = this.baseUrl + "/api/MatchPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<MatchPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchPlayerVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchPlayerVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/MatchPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class OfficialsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<OfficialVm[]> {
        let url_ = this.baseUrl + "/api/Officials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<OfficialVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficialVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficialVm[]>(null as any);
    }

    create(command: CreateOfficialCommand): Promise<OfficialDetailVm> {
        let url_ = this.baseUrl + "/api/Officials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<OfficialDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OfficialDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficialDetailVm>(null as any);
    }

    getPaginated(filter_Name: string | null | undefined, filter_Surname: string | null | undefined, filter_CountryOfBirth: string | null | undefined, filter_CityOfBirth: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfOfficialVm> {
        let url_ = this.baseUrl + "/api/Officials/search?";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Surname !== undefined && filter_Surname !== null)
            url_ += "Filter.Surname=" + encodeURIComponent("" + filter_Surname) + "&";
        if (filter_CountryOfBirth !== undefined && filter_CountryOfBirth !== null)
            url_ += "Filter.CountryOfBirth=" + encodeURIComponent("" + filter_CountryOfBirth) + "&";
        if (filter_CityOfBirth !== undefined && filter_CityOfBirth !== null)
            url_ += "Filter.CityOfBirth=" + encodeURIComponent("" + filter_CityOfBirth) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfOfficialVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfOfficialVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfOfficialVm>(null as any);
    }

    getById(id: number): Promise<OfficialDetailVm> {
        let url_ = this.baseUrl + "/api/Officials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<OfficialDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficialDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficialDetailVm>(null as any);
    }

    update(id: number, command: UpdateOfficialCommandOfOfficial): Promise<OfficialDetailVm> {
        let url_ = this.baseUrl + "/api/Officials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<OfficialDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficialDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficialDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Officials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updatePin(id: number, command: UpdateOfficialPinCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Officials/{id}/pin";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePin(_response));
        });
    }

    protected processUpdatePin(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PersonsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<PersonVm[]> {
        let url_ = this.baseUrl + "/api/Persons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PersonVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonVm[]>(null as any);
    }

    create(command: CreatePersonCommandOfPerson): Promise<PersonVm> {
        let url_ = this.baseUrl + "/api/Persons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<PersonVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PersonVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonVm>(null as any);
    }

    searchAll(input: string | null | undefined): Promise<PersonVm[]> {
        let url_ = this.baseUrl + "/api/Persons/search?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchAll(_response));
        });
    }

    protected processSearchAll(response: Response): Promise<PersonVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonVm[]>(null as any);
    }

    update(id: number, command: UpdatePersonCommandOfPerson): Promise<PersonVm> {
        let url_ = this.baseUrl + "/api/Persons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<PersonVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Persons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PlayersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<PlayerVm[]> {
        let url_ = this.baseUrl + "/api/Players";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PlayerVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlayerVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerVm[]>(null as any);
    }

    create(command: CreatePlayerCommand): Promise<PlayerDetailVm> {
        let url_ = this.baseUrl + "/api/Players";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<PlayerDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PlayerDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerDetailVm>(null as any);
    }

    getPaginated(filter_Name: string | null | undefined, filter_Surname: string | null | undefined, filter_CountryOfBirth: string | null | undefined, filter_CityOfBirth: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfPlayerVm> {
        let url_ = this.baseUrl + "/api/Players/search?";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Surname !== undefined && filter_Surname !== null)
            url_ += "Filter.Surname=" + encodeURIComponent("" + filter_Surname) + "&";
        if (filter_CountryOfBirth !== undefined && filter_CountryOfBirth !== null)
            url_ += "Filter.CountryOfBirth=" + encodeURIComponent("" + filter_CountryOfBirth) + "&";
        if (filter_CityOfBirth !== undefined && filter_CityOfBirth !== null)
            url_ += "Filter.CityOfBirth=" + encodeURIComponent("" + filter_CityOfBirth) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfPlayerVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfPlayerVm>(null as any);
    }

    getLightProfile(id: number): Promise<PlayerLightProfileVm> {
        let url_ = this.baseUrl + "/api/Players/{id}/light-profile";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLightProfile(_response));
        });
    }

    protected processGetLightProfile(response: Response): Promise<PlayerLightProfileVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerLightProfileVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerLightProfileVm>(null as any);
    }

    getById(id: number): Promise<PlayerDetailVm> {
        let url_ = this.baseUrl + "/api/Players/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<PlayerDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerDetailVm>(null as any);
    }

    update(id: number, command: UpdatePlayerCommandOfPlayer): Promise<PlayerDetailVm> {
        let url_ = this.baseUrl + "/api/Players/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<PlayerDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Players/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPlayers(playerIds: number[] | null | undefined): Promise<PlayerExtendedVm[]> {
        let url_ = this.baseUrl + "/api/Players/extended-info?";
        if (playerIds !== undefined && playerIds !== null)
            playerIds && playerIds.forEach(item => { url_ += "playerIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPlayers(_response));
        });
    }

    protected processGetPlayers(response: Response): Promise<PlayerExtendedVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlayerExtendedVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerExtendedVm[]>(null as any);
    }

    getPlayerStats(playerId: number | undefined, competitionId: number | null | undefined, matchId: number | null | undefined): Promise<PlayerStatsVm> {
        let url_ = this.baseUrl + "/api/Players/stats?";
        if (playerId === null)
            throw new Error("The parameter 'playerId' cannot be null.");
        else if (playerId !== undefined)
            url_ += "PlayerId=" + encodeURIComponent("" + playerId) + "&";
        if (competitionId !== undefined && competitionId !== null)
            url_ += "CompetitionId=" + encodeURIComponent("" + competitionId) + "&";
        if (matchId !== undefined && matchId !== null)
            url_ += "MatchId=" + encodeURIComponent("" + matchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPlayerStats(_response));
        });
    }

    protected processGetPlayerStats(response: Response): Promise<PlayerStatsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerStatsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerStatsVm>(null as any);
    }
}

export class SignalRDocsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    matchHubContract(): Promise<MatchMessage> {
        let url_ = this.baseUrl + "/match";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMatchHubContract(_response));
        });
    }

    protected processMatchHubContract(response: Response): Promise<MatchMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchMessage>(null as any);
    }
}

export class TeamCoachesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateTeamCoachCommandOfTeamCoach): Promise<TeamCoachVm> {
        let url_ = this.baseUrl + "/api/TeamCoaches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<TeamCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TeamCoachVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamCoachVm>(null as any);
    }

    update(id: number, command: UpdateTeamCoachCommandOfTeamCoach): Promise<TeamCoachVm> {
        let url_ = this.baseUrl + "/api/TeamCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<TeamCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamCoachVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamCoachVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/TeamCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TeamPlayersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateTeamPlayerCommandOfTeamPlayer): Promise<TeamPlayerVm> {
        let url_ = this.baseUrl + "/api/TeamPlayers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<TeamPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TeamPlayerVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamPlayerVm>(null as any);
    }

    update(id: number, command: UpdateTeamPlayerCommandOfTeamPlayer): Promise<TeamPlayerVm> {
        let url_ = this.baseUrl + "/api/TeamPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<TeamPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamPlayerVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamPlayerVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/TeamPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TeamsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(federationId: number | null | undefined): Promise<TeamVm[]> {
        let url_ = this.baseUrl + "/api/Teams?";
        if (federationId !== undefined && federationId !== null)
            url_ += "federationId=" + encodeURIComponent("" + federationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<TeamVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamVm[]>(null as any);
    }

    create(command: CreateTeamCommandOfTeam): Promise<TeamDetailVm> {
        let url_ = this.baseUrl + "/api/Teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<TeamDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TeamDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDetailVm>(null as any);
    }

    getPaginated(filter_NameUniversal: string | null | undefined, filter_ShortName: string | null | undefined, filter_ActiveFrom: Date | null | undefined, filter_ActiveTo: Date | null | undefined, filter_IsPro: boolean | null | undefined, filter_Club: string | null | undefined, filter_Category: string | null | undefined, filter_Country: string | null | undefined, filter_City: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfTeamVm> {
        let url_ = this.baseUrl + "/api/Teams/search?";
        if (filter_NameUniversal !== undefined && filter_NameUniversal !== null)
            url_ += "Filter.NameUniversal=" + encodeURIComponent("" + filter_NameUniversal) + "&";
        if (filter_ShortName !== undefined && filter_ShortName !== null)
            url_ += "Filter.ShortName=" + encodeURIComponent("" + filter_ShortName) + "&";
        if (filter_ActiveFrom !== undefined && filter_ActiveFrom !== null)
            url_ += "Filter.ActiveFrom=" + encodeURIComponent(filter_ActiveFrom ? "" + filter_ActiveFrom.toISOString() : "") + "&";
        if (filter_ActiveTo !== undefined && filter_ActiveTo !== null)
            url_ += "Filter.ActiveTo=" + encodeURIComponent(filter_ActiveTo ? "" + filter_ActiveTo.toISOString() : "") + "&";
        if (filter_IsPro !== undefined && filter_IsPro !== null)
            url_ += "Filter.IsPro=" + encodeURIComponent("" + filter_IsPro) + "&";
        if (filter_Club !== undefined && filter_Club !== null)
            url_ += "Filter.Club=" + encodeURIComponent("" + filter_Club) + "&";
        if (filter_Category !== undefined && filter_Category !== null)
            url_ += "Filter.Category=" + encodeURIComponent("" + filter_Category) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (filter_City !== undefined && filter_City !== null)
            url_ += "Filter.City=" + encodeURIComponent("" + filter_City) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfTeamVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTeamVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTeamVm>(null as any);
    }

    getById(id: number): Promise<TeamDetailVm> {
        let url_ = this.baseUrl + "/api/Teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<TeamDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDetailVm>(null as any);
    }

    update(id: number, command: UpdateTeamCommandOfTeam): Promise<TeamDetailVm> {
        let url_ = this.baseUrl + "/api/Teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<TeamDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getTeamMinInfo(competitionId: number | null | undefined, teamIds: number[] | null | undefined): Promise<TeamMinInfoDto[]> {
        let url_ = this.baseUrl + "/api/Teams/min-info?";
        if (competitionId !== undefined && competitionId !== null)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        if (teamIds !== undefined && teamIds !== null)
            teamIds && teamIds.forEach(item => { url_ += "teamIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTeamMinInfo(_response));
        });
    }

    protected processGetTeamMinInfo(response: Response): Promise<TeamMinInfoDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMinInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMinInfoDto[]>(null as any);
    }

    getPlayerStats(teamId: number | undefined, competitionId: number | null | undefined, matchId: number | null | undefined): Promise<TeamStatsVm> {
        let url_ = this.baseUrl + "/api/Teams/stats?";
        if (teamId === null)
            throw new Error("The parameter 'teamId' cannot be null.");
        else if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&";
        if (competitionId !== undefined && competitionId !== null)
            url_ += "CompetitionId=" + encodeURIComponent("" + competitionId) + "&";
        if (matchId !== undefined && matchId !== null)
            url_ += "MatchId=" + encodeURIComponent("" + matchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPlayerStats(_response));
        });
    }

    protected processGetPlayerStats(response: Response): Promise<TeamStatsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamStatsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamStatsVm>(null as any);
    }
}

export class UsersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<UserVm[]> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<UserVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserVm[]>(null as any);
    }

    create(command: CreateUserCommand): Promise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ApplicationUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApplicationUser.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUser>(null as any);
    }

    getById(id: string): Promise<UserVm> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<UserVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserVm>(null as any);
    }

    update(id: string, command: UpdateUserCommand): Promise<UserVm> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<UserVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserVm>(null as any);
    }

    delete(id: string): Promise<string> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ApiTokenCreatedVm implements IApiTokenCreatedVm {
    token!: string;
    apiToken!: ApiTokenVm;

    constructor(data?: IApiTokenCreatedVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.apiToken = _data["apiToken"] ? ApiTokenVm.fromJS(_data["apiToken"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiTokenCreatedVm {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTokenCreatedVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["apiToken"] = this.apiToken ? this.apiToken.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApiTokenCreatedVm {
    token: string;
    apiToken: ApiTokenVm;
}

export class ApiTokenVm implements IApiTokenVm {
    id!: number;
    tokenId!: string;
    name!: string;
    roles!: string;
    createdById!: string | undefined;
    createdDate!: Date;
    expiresAt!: Date;
    revokedDate!: Date | undefined;
    isRevoked!: boolean;
    isExpired!: boolean;
    isActive!: boolean;

    constructor(data?: IApiTokenVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tokenId = _data["tokenId"];
            this.name = _data["name"];
            this.roles = _data["roles"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.revokedDate = _data["revokedDate"] ? new Date(_data["revokedDate"].toString()) : <any>undefined;
            this.isRevoked = _data["isRevoked"];
            this.isExpired = _data["isExpired"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ApiTokenVm {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTokenVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tokenId"] = this.tokenId;
        data["name"] = this.name;
        data["roles"] = this.roles;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["revokedDate"] = this.revokedDate ? this.revokedDate.toISOString() : <any>undefined;
        data["isRevoked"] = this.isRevoked;
        data["isExpired"] = this.isExpired;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IApiTokenVm {
    id: number;
    tokenId: string;
    name: string;
    roles: string;
    createdById: string | undefined;
    createdDate: Date;
    expiresAt: Date;
    revokedDate: Date | undefined;
    isRevoked: boolean;
    isExpired: boolean;
    isActive: boolean;
}

export class CreateApiTokenRequest implements ICreateApiTokenRequest {
    name!: string | undefined;
    expiresAt!: Date;

    constructor(data?: ICreateApiTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateApiTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApiTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateApiTokenRequest {
    name: string | undefined;
    expiresAt: Date;
}

export class CategoryVm implements ICategoryVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    description!: string | undefined;
    gender!: string | undefined;
    shouldPlayersAdvanceCategoryYearly!: boolean;
    lowerAgeLimit!: number | undefined;
    upperAgeLimit!: number | undefined;

    constructor(data?: ICategoryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.description = _data["description"];
            this.gender = _data["gender"];
            this.shouldPlayersAdvanceCategoryYearly = _data["shouldPlayersAdvanceCategoryYearly"];
            this.lowerAgeLimit = _data["lowerAgeLimit"];
            this.upperAgeLimit = _data["upperAgeLimit"];
        }
    }

    static fromJS(data: any): CategoryVm {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["description"] = this.description;
        data["gender"] = this.gender;
        data["shouldPlayersAdvanceCategoryYearly"] = this.shouldPlayersAdvanceCategoryYearly;
        data["lowerAgeLimit"] = this.lowerAgeLimit;
        data["upperAgeLimit"] = this.upperAgeLimit;
        return data;
    }
}

export interface ICategoryVm {
    id: number;
    name: string;
    nameUniversal: string;
    description: string | undefined;
    gender: string | undefined;
    shouldPlayersAdvanceCategoryYearly: boolean;
    lowerAgeLimit: number | undefined;
    upperAgeLimit: number | undefined;
}

export class CreateCategoryCommandOfCategory implements ICreateCategoryCommandOfCategory {
    name!: string;
    nameUniversal!: string;
    description!: string | undefined;
    shouldPlayersAdvanceCategoryYearly!: boolean;
    lowerAgeLimit!: number | undefined;
    upperAgeLimit!: number | undefined;
    genderId!: GenderEnum;

    constructor(data?: ICreateCategoryCommandOfCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.description = _data["description"];
            this.shouldPlayersAdvanceCategoryYearly = _data["shouldPlayersAdvanceCategoryYearly"];
            this.lowerAgeLimit = _data["lowerAgeLimit"];
            this.upperAgeLimit = _data["upperAgeLimit"];
            this.genderId = _data["genderId"];
        }
    }

    static fromJS(data: any): CreateCategoryCommandOfCategory {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryCommandOfCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["description"] = this.description;
        data["shouldPlayersAdvanceCategoryYearly"] = this.shouldPlayersAdvanceCategoryYearly;
        data["lowerAgeLimit"] = this.lowerAgeLimit;
        data["upperAgeLimit"] = this.upperAgeLimit;
        data["genderId"] = this.genderId;
        return data;
    }
}

export interface ICreateCategoryCommandOfCategory {
    name: string;
    nameUniversal: string;
    description: string | undefined;
    shouldPlayersAdvanceCategoryYearly: boolean;
    lowerAgeLimit: number | undefined;
    upperAgeLimit: number | undefined;
    genderId: GenderEnum;
}

export enum GenderEnum {
    Male = 100,
    Female = 101,
    Mixed = 102,
}

export class UpdateCategoryCommandOfCategory extends CreateCategoryCommandOfCategory implements IUpdateCategoryCommandOfCategory {
    id!: number;

    constructor(data?: IUpdateCategoryCommandOfCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCategoryCommandOfCategory {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryCommandOfCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCategoryCommandOfCategory extends ICreateCategoryCommandOfCategory {
    id: number;
}

export class CityVm implements ICityVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    countryId!: number;
    country!: string;

    constructor(data?: ICityVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): CityVm {
        data = typeof data === 'object' ? data : {};
        let result = new CityVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        return data;
    }
}

export interface ICityVm {
    id: number;
    name: string;
    nameUniversal: string;
    countryId: number;
    country: string;
}

export class CreateCityCommandOfCity implements ICreateCityCommandOfCity {
    name!: string;
    nameUniversal!: string;
    countryId!: number;

    constructor(data?: ICreateCityCommandOfCity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): CreateCityCommandOfCity {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCityCommandOfCity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ICreateCityCommandOfCity {
    name: string;
    nameUniversal: string;
    countryId: number;
}

export class UpdateCityCommandOfCity extends CreateCityCommandOfCity implements IUpdateCityCommandOfCity {
    id!: number;

    constructor(data?: IUpdateCityCommandOfCity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCityCommandOfCity {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCityCommandOfCity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCityCommandOfCity extends ICreateCityCommandOfCity {
    id: number;
}

export class ClubCoachVm implements IClubCoachVm {
    id!: number | undefined;
    clubId!: number;
    coachId!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    club!: ClubVm;
    coach!: CoachVm;

    constructor(data?: IClubCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clubId = _data["clubId"];
            this.coachId = _data["coachId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.club = _data["club"] ? ClubVm.fromJS(_data["club"]) : <any>undefined;
            this.coach = _data["coach"] ? CoachVm.fromJS(_data["coach"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClubCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new ClubCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clubId"] = this.clubId;
        data["coachId"] = this.coachId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClubCoachVm {
    id: number | undefined;
    clubId: number;
    coachId: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    club: ClubVm;
    coach: CoachVm;
}

export class ClubVm implements IClubVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    venue!: string | undefined;
    president!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    isPro!: boolean;
    isNational!: boolean;
    federationId!: number | undefined;
    federation!: string;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;

    constructor(data?: IClubVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.president = _data["president"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.isPro = _data["isPro"];
            this.isNational = _data["isNational"];
            this.federationId = _data["federationId"];
            this.federation = _data["federation"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): ClubVm {
        data = typeof data === 'object' ? data : {};
        let result = new ClubVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["president"] = this.president;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["isPro"] = this.isPro;
        data["isNational"] = this.isNational;
        data["federationId"] = this.federationId;
        data["federation"] = this.federation;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        return data;
    }
}

export interface IClubVm {
    id: number;
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    venue: string | undefined;
    president: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    isPro: boolean;
    isNational: boolean;
    federationId: number | undefined;
    federation: string;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
}

export class CoachVm implements ICoachVm {
    id!: number;
    personId!: number;
    name!: string;
    surname!: string;
    countryOfBirthId!: number | undefined;
    countryOfBirth!: string | undefined;
    cityOfBirthId!: number | undefined;
    cityOfBirth!: string | undefined;

    constructor(data?: ICoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.cityOfBirthId = _data["cityOfBirthId"];
            this.cityOfBirth = _data["cityOfBirth"];
        }
    }

    static fromJS(data: any): CoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new CoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["countryOfBirth"] = this.countryOfBirth;
        data["cityOfBirthId"] = this.cityOfBirthId;
        data["cityOfBirth"] = this.cityOfBirth;
        return data;
    }
}

export interface ICoachVm {
    id: number;
    personId: number;
    name: string;
    surname: string;
    countryOfBirthId: number | undefined;
    countryOfBirth: string | undefined;
    cityOfBirthId: number | undefined;
    cityOfBirth: string | undefined;
}

export class CreateClubCoachCommandOfClubCoach implements ICreateClubCoachCommandOfClubCoach {
    clubId!: number;
    coachId!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;

    constructor(data?: ICreateClubCoachCommandOfClubCoach) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.coachId = _data["coachId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateClubCoachCommandOfClubCoach {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClubCoachCommandOfClubCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["coachId"] = this.coachId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateClubCoachCommandOfClubCoach {
    clubId: number;
    coachId: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
}

export class UpdateClubCoachCommandOfClubCoach extends CreateClubCoachCommandOfClubCoach implements IUpdateClubCoachCommandOfClubCoach {
    id!: number;

    constructor(data?: IUpdateClubCoachCommandOfClubCoach) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateClubCoachCommandOfClubCoach {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClubCoachCommandOfClubCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateClubCoachCommandOfClubCoach extends ICreateClubCoachCommandOfClubCoach {
    id: number;
}

export class ClubPlayerVm implements IClubPlayerVm {
    id!: number | undefined;
    clubId!: number;
    playerId!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    club!: ClubVm;
    player!: PlayerVm;

    constructor(data?: IClubPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clubId = _data["clubId"];
            this.playerId = _data["playerId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.club = _data["club"] ? ClubVm.fromJS(_data["club"]) : <any>undefined;
            this.player = _data["player"] ? PlayerVm.fromJS(_data["player"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClubPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new ClubPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clubId"] = this.clubId;
        data["playerId"] = this.playerId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClubPlayerVm {
    id: number | undefined;
    clubId: number;
    playerId: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    club: ClubVm;
    player: PlayerVm;
}

export class PlayerVm implements IPlayerVm {
    id!: number;
    personId!: number;
    name!: string;
    surname!: string;
    height!: string | undefined;
    weight!: string | undefined;
    dominantHand!: string | undefined;
    primaryPositionId!: PlayerPositionEnum | undefined;
    primaryPosition!: string | undefined;
    countryOfBirthId!: number | undefined;
    countryOfBirth!: string | undefined;
    cityOfBirthId!: number | undefined;
    cityOfBirth!: string | undefined;

    constructor(data?: IPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.dominantHand = _data["dominantHand"];
            this.primaryPositionId = _data["primaryPositionId"];
            this.primaryPosition = _data["primaryPosition"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.cityOfBirthId = _data["cityOfBirthId"];
            this.cityOfBirth = _data["cityOfBirth"];
        }
    }

    static fromJS(data: any): PlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["dominantHand"] = this.dominantHand;
        data["primaryPositionId"] = this.primaryPositionId;
        data["primaryPosition"] = this.primaryPosition;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["countryOfBirth"] = this.countryOfBirth;
        data["cityOfBirthId"] = this.cityOfBirthId;
        data["cityOfBirth"] = this.cityOfBirth;
        return data;
    }
}

export interface IPlayerVm {
    id: number;
    personId: number;
    name: string;
    surname: string;
    height: string | undefined;
    weight: string | undefined;
    dominantHand: string | undefined;
    primaryPositionId: PlayerPositionEnum | undefined;
    primaryPosition: string | undefined;
    countryOfBirthId: number | undefined;
    countryOfBirth: string | undefined;
    cityOfBirthId: number | undefined;
    cityOfBirth: string | undefined;
}

export enum PlayerPositionEnum {
    Goalkeeper = 400,
    Driver = 401,
    Left_Driver = 402,
    Right_Driver = 403,
    Central_Defender = 404,
    Left_Winger = 405,
    Right_Winger = 406,
    Center_Forward = 407,
}

export class CreateClubPlayerCommandOfClubPlayer implements ICreateClubPlayerCommandOfClubPlayer {
    clubId!: number;
    playerId!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;

    constructor(data?: ICreateClubPlayerCommandOfClubPlayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.playerId = _data["playerId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateClubPlayerCommandOfClubPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClubPlayerCommandOfClubPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["playerId"] = this.playerId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateClubPlayerCommandOfClubPlayer {
    clubId: number;
    playerId: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
}

export class UpdateClubPlayerCommandOfClubPlayer extends CreateClubPlayerCommandOfClubPlayer implements IUpdateClubPlayerCommandOfClubPlayer {
    id!: number;

    constructor(data?: IUpdateClubPlayerCommandOfClubPlayer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateClubPlayerCommandOfClubPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClubPlayerCommandOfClubPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateClubPlayerCommandOfClubPlayer extends ICreateClubPlayerCommandOfClubPlayer {
    id: number;
}

export class PaginatedListOfClubVm implements IPaginatedListOfClubVm {
    pageItems!: ClubVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfClubVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(ClubVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfClubVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfClubVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfClubVm {
    pageItems: ClubVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class ClubDetailVm extends ClubVm implements IClubDetailVm {
    logo!: string | undefined;
    teams!: TeamVm[];
    players!: ClubPlayerVm[];
    coaches!: ClubCoachVm[];

    constructor(data?: IClubDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logo = _data["logo"];
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamVm.fromJS(item));
            }
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(ClubPlayerVm.fromJS(item));
            }
            if (Array.isArray(_data["coaches"])) {
                this.coaches = [] as any;
                for (let item of _data["coaches"])
                    this.coaches!.push(ClubCoachVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClubDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new ClubDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        if (Array.isArray(this.coaches)) {
            data["coaches"] = [];
            for (let item of this.coaches)
                data["coaches"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IClubDetailVm extends IClubVm {
    logo: string | undefined;
    teams: TeamVm[];
    players: ClubPlayerVm[];
    coaches: ClubCoachVm[];
}

export class TeamVm implements ITeamVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    venue!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    isPro!: boolean;
    clubId!: number | undefined;
    federation!: string;
    federationId!: number;
    club!: string;
    categoryId!: number;
    category!: string;
    gender!: string;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;

    constructor(data?: ITeamVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.isPro = _data["isPro"];
            this.clubId = _data["clubId"];
            this.federation = _data["federation"];
            this.federationId = _data["federationId"];
            this.club = _data["club"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
            this.gender = _data["gender"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): TeamVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["isPro"] = this.isPro;
        data["clubId"] = this.clubId;
        data["federation"] = this.federation;
        data["federationId"] = this.federationId;
        data["club"] = this.club;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        data["gender"] = this.gender;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        return data;
    }
}

export interface ITeamVm {
    id: number;
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    venue: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    isPro: boolean;
    clubId: number | undefined;
    federation: string;
    federationId: number;
    club: string;
    categoryId: number;
    category: string;
    gender: string;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
}

export class CreateClubCommandOfClub implements ICreateClubCommandOfClub {
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    venue!: string | undefined;
    president!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    logo!: string | undefined;
    isPro!: boolean;
    isNational!: boolean;
    federationId!: number | undefined;
    countryId!: number | undefined;
    cityId!: number | undefined;
    teamCategories!: number[] | undefined;

    constructor(data?: ICreateClubCommandOfClub) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.president = _data["president"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.logo = _data["logo"];
            this.isPro = _data["isPro"];
            this.isNational = _data["isNational"];
            this.federationId = _data["federationId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            if (Array.isArray(_data["teamCategories"])) {
                this.teamCategories = [] as any;
                for (let item of _data["teamCategories"])
                    this.teamCategories!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateClubCommandOfClub {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClubCommandOfClub();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["president"] = this.president;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["logo"] = this.logo;
        data["isPro"] = this.isPro;
        data["isNational"] = this.isNational;
        data["federationId"] = this.federationId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        if (Array.isArray(this.teamCategories)) {
            data["teamCategories"] = [];
            for (let item of this.teamCategories)
                data["teamCategories"].push(item);
        }
        return data;
    }
}

export interface ICreateClubCommandOfClub {
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    venue: string | undefined;
    president: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    logo: string | undefined;
    isPro: boolean;
    isNational: boolean;
    federationId: number | undefined;
    countryId: number | undefined;
    cityId: number | undefined;
    teamCategories: number[] | undefined;
}

export class UpdateClubCommandOfClub extends CreateClubCommandOfClub implements IUpdateClubCommandOfClub {
    id!: number;

    constructor(data?: IUpdateClubCommandOfClub) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateClubCommandOfClub {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClubCommandOfClub();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateClubCommandOfClub extends ICreateClubCommandOfClub {
    id: number;
}

export class PaginatedListOfCoachVm implements IPaginatedListOfCoachVm {
    pageItems!: CoachVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(CoachVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfCoachVm {
    pageItems: CoachVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class CoachDetailVm implements ICoachDetailVm {
    id!: number;
    personId!: number;
    person!: PersonVm;
    matches!: MatchCoachVm[];
    teams!: TeamCoachVm[];
    clubs!: ClubCoachVm[];

    constructor(data?: ICoachDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? PersonVm.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchCoachVm.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamCoachVm.fromJS(item));
            }
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(ClubCoachVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoachDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new CoachDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoachDetailVm {
    id: number;
    personId: number;
    person: PersonVm;
    matches: MatchCoachVm[];
    teams: TeamCoachVm[];
    clubs: ClubCoachVm[];
}

export class PersonVm implements IPersonVm {
    id!: number;
    name!: string;
    surname!: string;
    birthDate!: Date;
    nationality!: string | undefined;
    address!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    photo!: string | undefined;
    countryOfBirthId!: number | undefined;
    countryOfBirth!: string | undefined;
    cityOfBirthId!: number | undefined;
    cityOfBirth!: string | undefined;
    coachId!: number | undefined;
    officialId!: number | undefined;
    playerId!: number | undefined;
    coach!: CoachVm | undefined;
    official!: OfficialVm | undefined;
    player!: PlayerVm | undefined;

    constructor(data?: IPersonVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.nationality = _data["nationality"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.photo = _data["photo"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.cityOfBirthId = _data["cityOfBirthId"];
            this.cityOfBirth = _data["cityOfBirth"];
            this.coachId = _data["coachId"];
            this.officialId = _data["officialId"];
            this.playerId = _data["playerId"];
            this.coach = _data["coach"] ? CoachVm.fromJS(_data["coach"]) : <any>undefined;
            this.official = _data["official"] ? OfficialVm.fromJS(_data["official"]) : <any>undefined;
            this.player = _data["player"] ? PlayerVm.fromJS(_data["player"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonVm {
        data = typeof data === 'object' ? data : {};
        let result = new PersonVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["nationality"] = this.nationality;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["photo"] = this.photo;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["countryOfBirth"] = this.countryOfBirth;
        data["cityOfBirthId"] = this.cityOfBirthId;
        data["cityOfBirth"] = this.cityOfBirth;
        data["coachId"] = this.coachId;
        data["officialId"] = this.officialId;
        data["playerId"] = this.playerId;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPersonVm {
    id: number;
    name: string;
    surname: string;
    birthDate: Date;
    nationality: string | undefined;
    address: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    photo: string | undefined;
    countryOfBirthId: number | undefined;
    countryOfBirth: string | undefined;
    cityOfBirthId: number | undefined;
    cityOfBirth: string | undefined;
    coachId: number | undefined;
    officialId: number | undefined;
    playerId: number | undefined;
    coach: CoachVm | undefined;
    official: OfficialVm | undefined;
    player: PlayerVm | undefined;
}

export class OfficialVm implements IOfficialVm {
    id!: number;
    personId!: number;
    name!: string;
    surname!: string;
    title!: string | undefined;
    countryOfBirthId!: number | undefined;
    countryOfBirth!: string | undefined;
    cityOfBirthId!: number | undefined;
    cityOfBirth!: string | undefined;

    constructor(data?: IOfficialVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.title = _data["title"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.cityOfBirthId = _data["cityOfBirthId"];
            this.cityOfBirth = _data["cityOfBirth"];
        }
    }

    static fromJS(data: any): OfficialVm {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["title"] = this.title;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["countryOfBirth"] = this.countryOfBirth;
        data["cityOfBirthId"] = this.cityOfBirthId;
        data["cityOfBirth"] = this.cityOfBirth;
        return data;
    }
}

export interface IOfficialVm {
    id: number;
    personId: number;
    name: string;
    surname: string;
    title: string | undefined;
    countryOfBirthId: number | undefined;
    countryOfBirth: string | undefined;
    cityOfBirthId: number | undefined;
    cityOfBirth: string | undefined;
}

export class MatchCoachVm implements IMatchCoachVm {
    id!: number | undefined;
    matchId!: number;
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;
    match!: MatchVm;
    coach!: CoachVm;
    team!: TeamVm;
    role!: string;

    constructor(data?: IMatchCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
            this.match = _data["match"] ? MatchVm.fromJS(_data["match"]) : <any>undefined;
            this.coach = _data["coach"] ? CoachVm.fromJS(_data["coach"]) : <any>undefined;
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): MatchCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        data["match"] = this.match ? this.match.toJSON() : <any>undefined;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["role"] = this.role;
        return data;
    }
}

export interface IMatchCoachVm {
    id: number | undefined;
    matchId: number;
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
    match: MatchVm;
    coach: CoachVm;
    team: TeamVm;
    role: string;
}

export enum CoachRoleEnum {
    Head_Coach = 500,
    Assistant_Coach = 501,
}

export class MatchVm implements IMatchVm {
    id!: number;
    homeTeamId!: number;
    homeTeamDisplayName!: string;
    awayTeamId!: number;
    awayTeamDisplayName!: string | undefined;
    federationId!: number;
    federationDisplayName!: string;
    competitionId!: number;
    competitionDisplayName!: string;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;
    venue!: string | undefined;
    round!: string | undefined;
    number!: string | undefined;
    competitionStage!: string | undefined;
    matchSegmentLength!: number;
    startDate!: Date;
    endDate!: Date | undefined;
    statusId!: MatchStatusEnum;
    status!: string;
    matchSegmentId!: MatchSegmentEnum;
    matchSegment!: string;
    homeTeamGoalsTotal!: number | undefined;
    awayTeamGoalsTotal!: number | undefined;
    homeTeamGoalsQ1!: number | undefined;
    awayTeamGoalsQ1!: number | undefined;
    homeTeamGoalsQ2!: number | undefined;
    awayTeamGoalsQ2!: number | undefined;
    homeTeamGoalsQ3!: number | undefined;
    awayTeamGoalsQ3!: number | undefined;
    homeTeamGoalsQ4!: number | undefined;
    awayTeamGoalsQ4!: number | undefined;
    homeTeamGoalsOT!: number | undefined;
    awayTeamGoalsOT!: number | undefined;
    referees!: OfficialVm[];
    delegates!: OfficialVm[];
    secretaries!: OfficialVm[];
    disciplinaryNote!: string | undefined;

    constructor(data?: IMatchVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.homeTeamId = _data["homeTeamId"];
            this.homeTeamDisplayName = _data["homeTeamDisplayName"];
            this.awayTeamId = _data["awayTeamId"];
            this.awayTeamDisplayName = _data["awayTeamDisplayName"];
            this.federationId = _data["federationId"];
            this.federationDisplayName = _data["federationDisplayName"];
            this.competitionId = _data["competitionId"];
            this.competitionDisplayName = _data["competitionDisplayName"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.venue = _data["venue"];
            this.round = _data["round"];
            this.number = _data["number"];
            this.competitionStage = _data["competitionStage"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.matchSegment = _data["matchSegment"];
            this.homeTeamGoalsTotal = _data["homeTeamGoalsTotal"];
            this.awayTeamGoalsTotal = _data["awayTeamGoalsTotal"];
            this.homeTeamGoalsQ1 = _data["homeTeamGoalsQ1"];
            this.awayTeamGoalsQ1 = _data["awayTeamGoalsQ1"];
            this.homeTeamGoalsQ2 = _data["homeTeamGoalsQ2"];
            this.awayTeamGoalsQ2 = _data["awayTeamGoalsQ2"];
            this.homeTeamGoalsQ3 = _data["homeTeamGoalsQ3"];
            this.awayTeamGoalsQ3 = _data["awayTeamGoalsQ3"];
            this.homeTeamGoalsQ4 = _data["homeTeamGoalsQ4"];
            this.awayTeamGoalsQ4 = _data["awayTeamGoalsQ4"];
            this.homeTeamGoalsOT = _data["homeTeamGoalsOT"];
            this.awayTeamGoalsOT = _data["awayTeamGoalsOT"];
            if (Array.isArray(_data["referees"])) {
                this.referees = [] as any;
                for (let item of _data["referees"])
                    this.referees!.push(OfficialVm.fromJS(item));
            }
            if (Array.isArray(_data["delegates"])) {
                this.delegates = [] as any;
                for (let item of _data["delegates"])
                    this.delegates!.push(OfficialVm.fromJS(item));
            }
            if (Array.isArray(_data["secretaries"])) {
                this.secretaries = [] as any;
                for (let item of _data["secretaries"])
                    this.secretaries!.push(OfficialVm.fromJS(item));
            }
            this.disciplinaryNote = _data["disciplinaryNote"];
        }
    }

    static fromJS(data: any): MatchVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeTeamId"] = this.homeTeamId;
        data["homeTeamDisplayName"] = this.homeTeamDisplayName;
        data["awayTeamId"] = this.awayTeamId;
        data["awayTeamDisplayName"] = this.awayTeamDisplayName;
        data["federationId"] = this.federationId;
        data["federationDisplayName"] = this.federationDisplayName;
        data["competitionId"] = this.competitionId;
        data["competitionDisplayName"] = this.competitionDisplayName;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["venue"] = this.venue;
        data["round"] = this.round;
        data["number"] = this.number;
        data["competitionStage"] = this.competitionStage;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["matchSegmentId"] = this.matchSegmentId;
        data["matchSegment"] = this.matchSegment;
        data["homeTeamGoalsTotal"] = this.homeTeamGoalsTotal;
        data["awayTeamGoalsTotal"] = this.awayTeamGoalsTotal;
        data["homeTeamGoalsQ1"] = this.homeTeamGoalsQ1;
        data["awayTeamGoalsQ1"] = this.awayTeamGoalsQ1;
        data["homeTeamGoalsQ2"] = this.homeTeamGoalsQ2;
        data["awayTeamGoalsQ2"] = this.awayTeamGoalsQ2;
        data["homeTeamGoalsQ3"] = this.homeTeamGoalsQ3;
        data["awayTeamGoalsQ3"] = this.awayTeamGoalsQ3;
        data["homeTeamGoalsQ4"] = this.homeTeamGoalsQ4;
        data["awayTeamGoalsQ4"] = this.awayTeamGoalsQ4;
        data["homeTeamGoalsOT"] = this.homeTeamGoalsOT;
        data["awayTeamGoalsOT"] = this.awayTeamGoalsOT;
        if (Array.isArray(this.referees)) {
            data["referees"] = [];
            for (let item of this.referees)
                data["referees"].push(item.toJSON());
        }
        if (Array.isArray(this.delegates)) {
            data["delegates"] = [];
            for (let item of this.delegates)
                data["delegates"].push(item.toJSON());
        }
        if (Array.isArray(this.secretaries)) {
            data["secretaries"] = [];
            for (let item of this.secretaries)
                data["secretaries"].push(item.toJSON());
        }
        data["disciplinaryNote"] = this.disciplinaryNote;
        return data;
    }
}

export interface IMatchVm {
    id: number;
    homeTeamId: number;
    homeTeamDisplayName: string;
    awayTeamId: number;
    awayTeamDisplayName: string | undefined;
    federationId: number;
    federationDisplayName: string;
    competitionId: number;
    competitionDisplayName: string;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
    venue: string | undefined;
    round: string | undefined;
    number: string | undefined;
    competitionStage: string | undefined;
    matchSegmentLength: number;
    startDate: Date;
    endDate: Date | undefined;
    statusId: MatchStatusEnum;
    status: string;
    matchSegmentId: MatchSegmentEnum;
    matchSegment: string;
    homeTeamGoalsTotal: number | undefined;
    awayTeamGoalsTotal: number | undefined;
    homeTeamGoalsQ1: number | undefined;
    awayTeamGoalsQ1: number | undefined;
    homeTeamGoalsQ2: number | undefined;
    awayTeamGoalsQ2: number | undefined;
    homeTeamGoalsQ3: number | undefined;
    awayTeamGoalsQ3: number | undefined;
    homeTeamGoalsQ4: number | undefined;
    awayTeamGoalsQ4: number | undefined;
    homeTeamGoalsOT: number | undefined;
    awayTeamGoalsOT: number | undefined;
    referees: OfficialVm[];
    delegates: OfficialVm[];
    secretaries: OfficialVm[];
    disciplinaryNote: string | undefined;
}

export enum MatchStatusEnum {
    Not_Started = 200,
    First_Period = 201,
    Second_Period = 202,
    Third_Period = 203,
    Fourth_Period = 204,
    Overtime = 205,
    Finished = 206,
    Cancelled = 207,
}

export enum MatchSegmentEnum {
    Single = 300,
    Half = 301,
    Third = 302,
    Quarter = 303,
}

export class TeamCoachVm implements ITeamCoachVm {
    id!: number | undefined;
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    coach!: CoachVm;
    team!: TeamVm;
    role!: string;

    constructor(data?: ITeamCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.coach = _data["coach"] ? CoachVm.fromJS(_data["coach"]) : <any>undefined;
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): TeamCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["role"] = this.role;
        return data;
    }
}

export interface ITeamCoachVm {
    id: number | undefined;
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    coach: CoachVm;
    team: TeamVm;
    role: string;
}

export class CreateCoachCommand implements ICreateCoachCommand {
    personId!: number;
    clubs!: CreateClubCoachCommandOfClubCoach[] | undefined;
    teams!: CreateTeamCoachCommandOfTeamCoach[] | undefined;

    constructor(data?: ICreateCoachCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(CreateClubCoachCommandOfClubCoach.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(CreateTeamCoachCommandOfTeamCoach.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCoachCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCoachCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateCoachCommand {
    personId: number;
    clubs: CreateClubCoachCommandOfClubCoach[] | undefined;
    teams: CreateTeamCoachCommandOfTeamCoach[] | undefined;
}

export class CreateTeamCoachCommandOfTeamCoach implements ICreateTeamCoachCommandOfTeamCoach {
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;

    constructor(data?: ICreateTeamCoachCommandOfTeamCoach) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTeamCoachCommandOfTeamCoach {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamCoachCommandOfTeamCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateTeamCoachCommandOfTeamCoach {
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
}

export class CompetitionVm implements ICompetitionVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    extraCompetitionStages!: string[];
    season!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    venue!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    matchLogTemplateLanguage!: string | undefined;
    isPro!: boolean;
    isInternational!: boolean;
    gameLogPinConfirmationRequired!: boolean;
    federationId!: number;
    federation!: string;
    categoryId!: number | undefined;
    category!: string | undefined;
    competitionTypeId!: number | undefined;
    competitionType!: string | undefined;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;

    constructor(data?: ICompetitionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            if (Array.isArray(_data["extraCompetitionStages"])) {
                this.extraCompetitionStages = [] as any;
                for (let item of _data["extraCompetitionStages"])
                    this.extraCompetitionStages!.push(item);
            }
            this.season = _data["season"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.matchLogTemplateLanguage = _data["matchLogTemplateLanguage"];
            this.isPro = _data["isPro"];
            this.isInternational = _data["isInternational"];
            this.gameLogPinConfirmationRequired = _data["gameLogPinConfirmationRequired"];
            this.federationId = _data["federationId"];
            this.federation = _data["federation"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
            this.competitionTypeId = _data["competitionTypeId"];
            this.competitionType = _data["competitionType"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): CompetitionVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        if (Array.isArray(this.extraCompetitionStages)) {
            data["extraCompetitionStages"] = [];
            for (let item of this.extraCompetitionStages)
                data["extraCompetitionStages"].push(item);
        }
        data["season"] = this.season;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["matchLogTemplateLanguage"] = this.matchLogTemplateLanguage;
        data["isPro"] = this.isPro;
        data["isInternational"] = this.isInternational;
        data["gameLogPinConfirmationRequired"] = this.gameLogPinConfirmationRequired;
        data["federationId"] = this.federationId;
        data["federation"] = this.federation;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        data["competitionTypeId"] = this.competitionTypeId;
        data["competitionType"] = this.competitionType;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        return data;
    }
}

export interface ICompetitionVm {
    id: number;
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    extraCompetitionStages: string[];
    season: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    venue: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    matchLogTemplateLanguage: string | undefined;
    isPro: boolean;
    isInternational: boolean;
    gameLogPinConfirmationRequired: boolean;
    federationId: number;
    federation: string;
    categoryId: number | undefined;
    category: string | undefined;
    competitionTypeId: number | undefined;
    competitionType: string | undefined;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
}

export class PaginatedListOfCompetitionVm implements IPaginatedListOfCompetitionVm {
    pageItems!: CompetitionVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfCompetitionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(CompetitionVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfCompetitionVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCompetitionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfCompetitionVm {
    pageItems: CompetitionVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class CompetitionDetailVm extends CompetitionVm implements ICompetitionDetailVm {
    logo!: string | undefined;
    competitionTeams!: CompetitionTeamVm[];
    matches!: MatchVm[];

    constructor(data?: ICompetitionDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logo = _data["logo"];
            if (Array.isArray(_data["competitionTeams"])) {
                this.competitionTeams = [] as any;
                for (let item of _data["competitionTeams"])
                    this.competitionTeams!.push(CompetitionTeamVm.fromJS(item));
            }
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitionDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        if (Array.isArray(this.competitionTeams)) {
            data["competitionTeams"] = [];
            for (let item of this.competitionTeams)
                data["competitionTeams"].push(item.toJSON());
        }
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICompetitionDetailVm extends ICompetitionVm {
    logo: string | undefined;
    competitionTeams: CompetitionTeamVm[];
    matches: MatchVm[];
}

export class CompetitionTeamVm implements ICompetitionTeamVm {
    id!: number;
    description!: string | undefined;
    isDisqualified!: boolean;
    isSeed!: boolean;
    competitionId!: number;
    competition!: CompetitionVm;
    teamId!: number;
    team!: TeamVm;

    constructor(data?: ICompetitionTeamVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.isDisqualified = _data["isDisqualified"];
            this.isSeed = _data["isSeed"];
            this.competitionId = _data["competitionId"];
            this.competition = _data["competition"] ? CompetitionVm.fromJS(_data["competition"]) : <any>undefined;
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompetitionTeamVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionTeamVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["isDisqualified"] = this.isDisqualified;
        data["isSeed"] = this.isSeed;
        data["competitionId"] = this.competitionId;
        data["competition"] = this.competition ? this.competition.toJSON() : <any>undefined;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompetitionTeamVm {
    id: number;
    description: string | undefined;
    isDisqualified: boolean;
    isSeed: boolean;
    competitionId: number;
    competition: CompetitionVm;
    teamId: number;
    team: TeamVm;
}

export class CreateCompetitionCommandOfCompetition implements ICreateCompetitionCommandOfCompetition {
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    extraCompetitionStages!: string[] | undefined;
    season!: string;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    venue!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    logo!: string | undefined;
    matchLogTemplateLanguage!: string | undefined;
    isPro!: boolean;
    isInternational!: boolean;
    gameLogPinConfirmationRequired!: boolean;
    federationId!: number;
    categoryId!: number | undefined;
    competitionTypeId!: number | undefined;
    countryId!: number | undefined;
    cityId!: number | undefined;

    constructor(data?: ICreateCompetitionCommandOfCompetition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            if (Array.isArray(_data["extraCompetitionStages"])) {
                this.extraCompetitionStages = [] as any;
                for (let item of _data["extraCompetitionStages"])
                    this.extraCompetitionStages!.push(item);
            }
            this.season = _data["season"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.logo = _data["logo"];
            this.matchLogTemplateLanguage = _data["matchLogTemplateLanguage"];
            this.isPro = _data["isPro"];
            this.isInternational = _data["isInternational"];
            this.gameLogPinConfirmationRequired = _data["gameLogPinConfirmationRequired"];
            this.federationId = _data["federationId"];
            this.categoryId = _data["categoryId"];
            this.competitionTypeId = _data["competitionTypeId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
        }
    }

    static fromJS(data: any): CreateCompetitionCommandOfCompetition {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompetitionCommandOfCompetition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        if (Array.isArray(this.extraCompetitionStages)) {
            data["extraCompetitionStages"] = [];
            for (let item of this.extraCompetitionStages)
                data["extraCompetitionStages"].push(item);
        }
        data["season"] = this.season;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["logo"] = this.logo;
        data["matchLogTemplateLanguage"] = this.matchLogTemplateLanguage;
        data["isPro"] = this.isPro;
        data["isInternational"] = this.isInternational;
        data["gameLogPinConfirmationRequired"] = this.gameLogPinConfirmationRequired;
        data["federationId"] = this.federationId;
        data["categoryId"] = this.categoryId;
        data["competitionTypeId"] = this.competitionTypeId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        return data;
    }
}

export interface ICreateCompetitionCommandOfCompetition {
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    extraCompetitionStages: string[] | undefined;
    season: string;
    startDate: Date | undefined;
    endDate: Date | undefined;
    venue: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    logo: string | undefined;
    matchLogTemplateLanguage: string | undefined;
    isPro: boolean;
    isInternational: boolean;
    gameLogPinConfirmationRequired: boolean;
    federationId: number;
    categoryId: number | undefined;
    competitionTypeId: number | undefined;
    countryId: number | undefined;
    cityId: number | undefined;
}

export class UpdateCompetitionCommandOfCompetition extends CreateCompetitionCommandOfCompetition implements IUpdateCompetitionCommandOfCompetition {
    id!: number;

    constructor(data?: IUpdateCompetitionCommandOfCompetition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCompetitionCommandOfCompetition {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompetitionCommandOfCompetition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCompetitionCommandOfCompetition extends ICreateCompetitionCommandOfCompetition {
    id: number;
}

export class StandingsVm implements IStandingsVm {
    standingType!: StandingTypeEnum;
    rankings!: StandingVm[] | undefined;

    constructor(data?: IStandingsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standingType = _data["standingType"];
            if (Array.isArray(_data["rankings"])) {
                this.rankings = [] as any;
                for (let item of _data["rankings"])
                    this.rankings!.push(StandingVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StandingsVm {
        data = typeof data === 'object' ? data : {};
        let result = new StandingsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standingType"] = this.standingType;
        if (Array.isArray(this.rankings)) {
            data["rankings"] = [];
            for (let item of this.rankings)
                data["rankings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStandingsVm {
    standingType: StandingTypeEnum;
    rankings: StandingVm[] | undefined;
}

export enum StandingTypeEnum {
    Group = 1400,
    Knockout = 1401,
    Competition = 1402,
}

export class StandingVm implements IStandingVm {
    id!: number;
    competitionId!: number;
    competition!: string | undefined;
    team!: string | undefined;
    teamId!: number;
    played!: number;
    drawn!: number;
    won!: number;
    lost!: number;
    goalsScored!: number;
    goalsConceded!: number;
    goalsDiff!: number;
    points!: number;
    rank!: number;

    constructor(data?: IStandingVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.competitionId = _data["competitionId"];
            this.competition = _data["competition"];
            this.team = _data["team"];
            this.teamId = _data["teamId"];
            this.played = _data["played"];
            this.drawn = _data["drawn"];
            this.won = _data["won"];
            this.lost = _data["lost"];
            this.goalsScored = _data["goalsScored"];
            this.goalsConceded = _data["goalsConceded"];
            this.goalsDiff = _data["goalsDiff"];
            this.points = _data["points"];
            this.rank = _data["rank"];
        }
    }

    static fromJS(data: any): StandingVm {
        data = typeof data === 'object' ? data : {};
        let result = new StandingVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["competitionId"] = this.competitionId;
        data["competition"] = this.competition;
        data["team"] = this.team;
        data["teamId"] = this.teamId;
        data["played"] = this.played;
        data["drawn"] = this.drawn;
        data["won"] = this.won;
        data["lost"] = this.lost;
        data["goalsScored"] = this.goalsScored;
        data["goalsConceded"] = this.goalsConceded;
        data["goalsDiff"] = this.goalsDiff;
        data["points"] = this.points;
        data["rank"] = this.rank;
        return data;
    }
}

export interface IStandingVm {
    id: number;
    competitionId: number;
    competition: string | undefined;
    team: string | undefined;
    teamId: number;
    played: number;
    drawn: number;
    won: number;
    lost: number;
    goalsScored: number;
    goalsConceded: number;
    goalsDiff: number;
    points: number;
    rank: number;
}

export class CreateCompetitionTeamCommand implements ICreateCompetitionTeamCommand {
    description!: string | undefined;
    isDisqualified!: boolean;
    isSeed!: boolean;
    competitionId!: number;
    teamId!: number;

    constructor(data?: ICreateCompetitionTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.isDisqualified = _data["isDisqualified"];
            this.isSeed = _data["isSeed"];
            this.competitionId = _data["competitionId"];
            this.teamId = _data["teamId"];
        }
    }

    static fromJS(data: any): CreateCompetitionTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompetitionTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isDisqualified"] = this.isDisqualified;
        data["isSeed"] = this.isSeed;
        data["competitionId"] = this.competitionId;
        data["teamId"] = this.teamId;
        return data;
    }
}

export interface ICreateCompetitionTeamCommand {
    description: string | undefined;
    isDisqualified: boolean;
    isSeed: boolean;
    competitionId: number;
    teamId: number;
}

export class UpdateCompetitionTeamCommandOfCompetitionTeam extends CreateCompetitionTeamCommand implements IUpdateCompetitionTeamCommandOfCompetitionTeam {
    id!: number;

    constructor(data?: IUpdateCompetitionTeamCommandOfCompetitionTeam) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCompetitionTeamCommandOfCompetitionTeam {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompetitionTeamCommandOfCompetitionTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCompetitionTeamCommandOfCompetitionTeam extends ICreateCompetitionTeamCommand {
    id: number;
}

export class CompetitionTypeVm implements ICompetitionTypeVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    description!: string | undefined;
    code!: string | undefined;

    constructor(data?: ICompetitionTypeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.description = _data["description"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CompetitionTypeVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionTypeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["description"] = this.description;
        data["code"] = this.code;
        return data;
    }
}

export interface ICompetitionTypeVm {
    id: number;
    name: string;
    nameUniversal: string;
    description: string | undefined;
    code: string | undefined;
}

export class CreateCompetitionTypeCommandOfCompetitionType implements ICreateCompetitionTypeCommandOfCompetitionType {
    name!: string;
    nameUniversal!: string;
    description!: string | undefined;
    code!: string | undefined;

    constructor(data?: ICreateCompetitionTypeCommandOfCompetitionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.description = _data["description"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateCompetitionTypeCommandOfCompetitionType {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompetitionTypeCommandOfCompetitionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["description"] = this.description;
        data["code"] = this.code;
        return data;
    }
}

export interface ICreateCompetitionTypeCommandOfCompetitionType {
    name: string;
    nameUniversal: string;
    description: string | undefined;
    code: string | undefined;
}

export class UpdateCompetitionTypeCommandOfCompetitionType extends CreateCompetitionTypeCommandOfCompetitionType implements IUpdateCompetitionTypeCommandOfCompetitionType {
    id!: number;

    constructor(data?: IUpdateCompetitionTypeCommandOfCompetitionType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCompetitionTypeCommandOfCompetitionType {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompetitionTypeCommandOfCompetitionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCompetitionTypeCommandOfCompetitionType extends ICreateCompetitionTypeCommandOfCompetitionType {
    id: number;
}

export class CountryVm implements ICountryVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    code!: string | undefined;

    constructor(data?: ICountryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CountryVm {
        data = typeof data === 'object' ? data : {};
        let result = new CountryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["code"] = this.code;
        return data;
    }
}

export interface ICountryVm {
    id: number;
    name: string;
    nameUniversal: string;
    code: string | undefined;
}

export class CountryDetailVm extends CountryVm implements ICountryDetailVm {
    cities!: CityVm[];

    constructor(data?: ICountryDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CityVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICountryDetailVm extends ICountryVm {
    cities: CityVm[];
}

export class CreateCountryCommandOfCountry implements ICreateCountryCommandOfCountry {
    name!: string;
    nameUniversal!: string;
    code!: string | undefined;

    constructor(data?: ICreateCountryCommandOfCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateCountryCommandOfCountry {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryCommandOfCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["code"] = this.code;
        return data;
    }
}

export interface ICreateCountryCommandOfCountry {
    name: string;
    nameUniversal: string;
    code: string | undefined;
}

export class UpdateCountryCommandOfCountry extends CreateCountryCommandOfCountry implements IUpdateCountryCommandOfCountry {
    id!: number;

    constructor(data?: IUpdateCountryCommandOfCountry) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCountryCommandOfCountry {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryCommandOfCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCountryCommandOfCountry extends ICreateCountryCommandOfCountry {
    id: number;
}

export class EventLightVm implements IEventLightVm {
    id!: number;
    matchId!: number;
    type!: string | undefined;
    periodId!: number;
    period!: string | undefined;
    minute!: number;
    seconds!: number;
    shot!: EventShotLightVm | undefined;
    exclusion!: EventExclusionLightVm | undefined;
    turnover!: EventTurnoverLightVm | undefined;
    swimoff!: EventSwimoffLightVm | undefined;
    card!: EventCardLightVm | undefined;
    timeout!: EventTimeoutLightVm | undefined;
    challenge!: EventChallengeLightVm | undefined;
    goalkeeperChange!: EventGoalkeeperChangeLightVm | undefined;
    activeHomeGoalkeeperMatchPlayerId!: number | undefined;
    activeAwayGoalkeeperMatchPlayerId!: number | undefined;
    refereeMistake!: number | undefined;

    constructor(data?: IEventLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.type = _data["type"];
            this.periodId = _data["periodId"];
            this.period = _data["period"];
            this.minute = _data["minute"];
            this.seconds = _data["seconds"];
            this.shot = _data["shot"] ? EventShotLightVm.fromJS(_data["shot"]) : <any>undefined;
            this.exclusion = _data["exclusion"] ? EventExclusionLightVm.fromJS(_data["exclusion"]) : <any>undefined;
            this.turnover = _data["turnover"] ? EventTurnoverLightVm.fromJS(_data["turnover"]) : <any>undefined;
            this.swimoff = _data["swimoff"] ? EventSwimoffLightVm.fromJS(_data["swimoff"]) : <any>undefined;
            this.card = _data["card"] ? EventCardLightVm.fromJS(_data["card"]) : <any>undefined;
            this.timeout = _data["timeout"] ? EventTimeoutLightVm.fromJS(_data["timeout"]) : <any>undefined;
            this.challenge = _data["challenge"] ? EventChallengeLightVm.fromJS(_data["challenge"]) : <any>undefined;
            this.goalkeeperChange = _data["goalkeeperChange"] ? EventGoalkeeperChangeLightVm.fromJS(_data["goalkeeperChange"]) : <any>undefined;
            this.activeHomeGoalkeeperMatchPlayerId = _data["activeHomeGoalkeeperMatchPlayerId"];
            this.activeAwayGoalkeeperMatchPlayerId = _data["activeAwayGoalkeeperMatchPlayerId"];
            this.refereeMistake = _data["refereeMistake"];
        }
    }

    static fromJS(data: any): EventLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["type"] = this.type;
        data["periodId"] = this.periodId;
        data["period"] = this.period;
        data["minute"] = this.minute;
        data["seconds"] = this.seconds;
        data["shot"] = this.shot ? this.shot.toJSON() : <any>undefined;
        data["exclusion"] = this.exclusion ? this.exclusion.toJSON() : <any>undefined;
        data["turnover"] = this.turnover ? this.turnover.toJSON() : <any>undefined;
        data["swimoff"] = this.swimoff ? this.swimoff.toJSON() : <any>undefined;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["timeout"] = this.timeout ? this.timeout.toJSON() : <any>undefined;
        data["challenge"] = this.challenge ? this.challenge.toJSON() : <any>undefined;
        data["goalkeeperChange"] = this.goalkeeperChange ? this.goalkeeperChange.toJSON() : <any>undefined;
        data["activeHomeGoalkeeperMatchPlayerId"] = this.activeHomeGoalkeeperMatchPlayerId;
        data["activeAwayGoalkeeperMatchPlayerId"] = this.activeAwayGoalkeeperMatchPlayerId;
        data["refereeMistake"] = this.refereeMistake;
        return data;
    }
}

export interface IEventLightVm {
    id: number;
    matchId: number;
    type: string | undefined;
    periodId: number;
    period: string | undefined;
    minute: number;
    seconds: number;
    shot: EventShotLightVm | undefined;
    exclusion: EventExclusionLightVm | undefined;
    turnover: EventTurnoverLightVm | undefined;
    swimoff: EventSwimoffLightVm | undefined;
    card: EventCardLightVm | undefined;
    timeout: EventTimeoutLightVm | undefined;
    challenge: EventChallengeLightVm | undefined;
    goalkeeperChange: EventGoalkeeperChangeLightVm | undefined;
    activeHomeGoalkeeperMatchPlayerId: number | undefined;
    activeAwayGoalkeeperMatchPlayerId: number | undefined;
    refereeMistake: number | undefined;
}

export class EventShotLightVm implements IEventShotLightVm {
    teamId!: number;
    type!: string | undefined;
    takenById!: number;
    blockedById!: number | undefined;
    assistedById!: number | undefined;
    savedById!: number | undefined;
    isGoal!: boolean;
    isFastBreak!: boolean;
    isDirectFromFoul!: boolean;
    shotTechnique!: number | undefined;
    fakeCount!: number;
    locationX!: number | undefined;
    locationY!: number | undefined;
    targetX!: number | undefined;
    targetY!: number | undefined;

    constructor(data?: IEventShotLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.type = _data["type"];
            this.takenById = _data["takenById"];
            this.blockedById = _data["blockedById"];
            this.assistedById = _data["assistedById"];
            this.savedById = _data["savedById"];
            this.isGoal = _data["isGoal"];
            this.isFastBreak = _data["isFastBreak"];
            this.isDirectFromFoul = _data["isDirectFromFoul"];
            this.shotTechnique = _data["shotTechnique"];
            this.fakeCount = _data["fakeCount"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
            this.targetX = _data["targetX"];
            this.targetY = _data["targetY"];
        }
    }

    static fromJS(data: any): EventShotLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventShotLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["type"] = this.type;
        data["takenById"] = this.takenById;
        data["blockedById"] = this.blockedById;
        data["assistedById"] = this.assistedById;
        data["savedById"] = this.savedById;
        data["isGoal"] = this.isGoal;
        data["isFastBreak"] = this.isFastBreak;
        data["isDirectFromFoul"] = this.isDirectFromFoul;
        data["shotTechnique"] = this.shotTechnique;
        data["fakeCount"] = this.fakeCount;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        data["targetX"] = this.targetX;
        data["targetY"] = this.targetY;
        return data;
    }
}

export interface IEventShotLightVm {
    teamId: number;
    type: string | undefined;
    takenById: number;
    blockedById: number | undefined;
    assistedById: number | undefined;
    savedById: number | undefined;
    isGoal: boolean;
    isFastBreak: boolean;
    isDirectFromFoul: boolean;
    shotTechnique: number | undefined;
    fakeCount: number;
    locationX: number | undefined;
    locationY: number | undefined;
    targetX: number | undefined;
    targetY: number | undefined;
}

export class EventExclusionLightVm implements IEventExclusionLightVm {
    teamId!: number;
    type!: string | undefined;
    excludedPlayerId!: number | undefined;
    fouledPlayerId!: number | undefined;
    assistedById!: number | undefined;
    locationX!: number | undefined;
    locationY!: number | undefined;

    constructor(data?: IEventExclusionLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.type = _data["type"];
            this.excludedPlayerId = _data["excludedPlayerId"];
            this.fouledPlayerId = _data["fouledPlayerId"];
            this.assistedById = _data["assistedById"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
        }
    }

    static fromJS(data: any): EventExclusionLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventExclusionLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["type"] = this.type;
        data["excludedPlayerId"] = this.excludedPlayerId;
        data["fouledPlayerId"] = this.fouledPlayerId;
        data["assistedById"] = this.assistedById;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        return data;
    }
}

export interface IEventExclusionLightVm {
    teamId: number;
    type: string | undefined;
    excludedPlayerId: number | undefined;
    fouledPlayerId: number | undefined;
    assistedById: number | undefined;
    locationX: number | undefined;
    locationY: number | undefined;
}

export class EventTurnoverLightVm implements IEventTurnoverLightVm {
    teamId!: number;
    type!: string | undefined;
    lostPossesionPlayerId!: number;
    wonPossesionPlayerId!: number | undefined;

    constructor(data?: IEventTurnoverLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.type = _data["type"];
            this.lostPossesionPlayerId = _data["lostPossesionPlayerId"];
            this.wonPossesionPlayerId = _data["wonPossesionPlayerId"];
        }
    }

    static fromJS(data: any): EventTurnoverLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventTurnoverLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["type"] = this.type;
        data["lostPossesionPlayerId"] = this.lostPossesionPlayerId;
        data["wonPossesionPlayerId"] = this.wonPossesionPlayerId;
        return data;
    }
}

export interface IEventTurnoverLightVm {
    teamId: number;
    type: string | undefined;
    lostPossesionPlayerId: number;
    wonPossesionPlayerId: number | undefined;
}

export class EventSwimoffLightVm implements IEventSwimoffLightVm {
    winnerTeamId!: number | undefined;
    winnerSwimmerId!: number | undefined;

    constructor(data?: IEventSwimoffLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.winnerTeamId = _data["winnerTeamId"];
            this.winnerSwimmerId = _data["winnerSwimmerId"];
        }
    }

    static fromJS(data: any): EventSwimoffLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventSwimoffLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["winnerTeamId"] = this.winnerTeamId;
        data["winnerSwimmerId"] = this.winnerSwimmerId;
        return data;
    }
}

export interface IEventSwimoffLightVm {
    winnerTeamId: number | undefined;
    winnerSwimmerId: number | undefined;
}

export class EventCardLightVm implements IEventCardLightVm {
    teamId!: number;
    cardedPlayerId!: number | undefined;

    constructor(data?: IEventCardLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.cardedPlayerId = _data["cardedPlayerId"];
        }
    }

    static fromJS(data: any): EventCardLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventCardLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["cardedPlayerId"] = this.cardedPlayerId;
        return data;
    }
}

export interface IEventCardLightVm {
    teamId: number;
    cardedPlayerId: number | undefined;
}

export class EventTimeoutLightVm implements IEventTimeoutLightVm {
    teamId!: number;

    constructor(data?: IEventTimeoutLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
        }
    }

    static fromJS(data: any): EventTimeoutLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventTimeoutLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        return data;
    }
}

export interface IEventTimeoutLightVm {
    teamId: number;
}

export class EventChallengeLightVm implements IEventChallengeLightVm {
    teamId!: number;
    isSuccessful!: boolean;

    constructor(data?: IEventChallengeLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any): EventChallengeLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventChallengeLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface IEventChallengeLightVm {
    teamId: number;
    isSuccessful: boolean;
}

export class EventGoalkeeperChangeLightVm implements IEventGoalkeeperChangeLightVm {
    teamId!: number;
    newGoalkeeperMatchPlayerId!: number;
    previousGoalkeeperMatchPlayerId!: number | undefined;

    constructor(data?: IEventGoalkeeperChangeLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.newGoalkeeperMatchPlayerId = _data["newGoalkeeperMatchPlayerId"];
            this.previousGoalkeeperMatchPlayerId = _data["previousGoalkeeperMatchPlayerId"];
        }
    }

    static fromJS(data: any): EventGoalkeeperChangeLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventGoalkeeperChangeLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["newGoalkeeperMatchPlayerId"] = this.newGoalkeeperMatchPlayerId;
        data["previousGoalkeeperMatchPlayerId"] = this.previousGoalkeeperMatchPlayerId;
        return data;
    }
}

export interface IEventGoalkeeperChangeLightVm {
    teamId: number;
    newGoalkeeperMatchPlayerId: number;
    previousGoalkeeperMatchPlayerId: number | undefined;
}

export class EventVm implements IEventVm {
    id!: number;
    periodId!: EventPeriodEnum;
    period!: string;
    minute!: number;
    seconds!: number;
    matchId!: number;
    match!: MatchVm;
    typeId!: EventTypeEnum;
    type!: string;
    timeoutId!: number | undefined;
    timeout!: EventTimeoutVm | undefined;
    swimoffId!: number | undefined;
    swimoff!: EventSwimoffVm | undefined;
    cardId!: number | undefined;
    card!: EventCardVm | undefined;
    turnoverId!: number | undefined;
    turnover!: EventTurnoverVm | undefined;
    exclusionId!: number | undefined;
    exclusion!: EventExclusionVm | undefined;
    shotId!: number | undefined;
    shot!: EventShotVm | undefined;
    challengeId!: number | undefined;
    challenge!: EventChallengeVm | undefined;
    goalkeeperChangeId!: number | undefined;
    goalkeeperChange!: EventGoalkeeperChangeVm | undefined;
    activeHomeGoalkeeperMatchPlayerId!: number | undefined;
    activeAwayGoalkeeperMatchPlayerId!: number | undefined;
    refereeMistake!: number | undefined;

    constructor(data?: IEventVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.periodId = _data["periodId"];
            this.period = _data["period"];
            this.minute = _data["minute"];
            this.seconds = _data["seconds"];
            this.matchId = _data["matchId"];
            this.match = _data["match"] ? MatchVm.fromJS(_data["match"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.timeoutId = _data["timeoutId"];
            this.timeout = _data["timeout"] ? EventTimeoutVm.fromJS(_data["timeout"]) : <any>undefined;
            this.swimoffId = _data["swimoffId"];
            this.swimoff = _data["swimoff"] ? EventSwimoffVm.fromJS(_data["swimoff"]) : <any>undefined;
            this.cardId = _data["cardId"];
            this.card = _data["card"] ? EventCardVm.fromJS(_data["card"]) : <any>undefined;
            this.turnoverId = _data["turnoverId"];
            this.turnover = _data["turnover"] ? EventTurnoverVm.fromJS(_data["turnover"]) : <any>undefined;
            this.exclusionId = _data["exclusionId"];
            this.exclusion = _data["exclusion"] ? EventExclusionVm.fromJS(_data["exclusion"]) : <any>undefined;
            this.shotId = _data["shotId"];
            this.shot = _data["shot"] ? EventShotVm.fromJS(_data["shot"]) : <any>undefined;
            this.challengeId = _data["challengeId"];
            this.challenge = _data["challenge"] ? EventChallengeVm.fromJS(_data["challenge"]) : <any>undefined;
            this.goalkeeperChangeId = _data["goalkeeperChangeId"];
            this.goalkeeperChange = _data["goalkeeperChange"] ? EventGoalkeeperChangeVm.fromJS(_data["goalkeeperChange"]) : <any>undefined;
            this.activeHomeGoalkeeperMatchPlayerId = _data["activeHomeGoalkeeperMatchPlayerId"];
            this.activeAwayGoalkeeperMatchPlayerId = _data["activeAwayGoalkeeperMatchPlayerId"];
            this.refereeMistake = _data["refereeMistake"];
        }
    }

    static fromJS(data: any): EventVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["periodId"] = this.periodId;
        data["period"] = this.period;
        data["minute"] = this.minute;
        data["seconds"] = this.seconds;
        data["matchId"] = this.matchId;
        data["match"] = this.match ? this.match.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["timeoutId"] = this.timeoutId;
        data["timeout"] = this.timeout ? this.timeout.toJSON() : <any>undefined;
        data["swimoffId"] = this.swimoffId;
        data["swimoff"] = this.swimoff ? this.swimoff.toJSON() : <any>undefined;
        data["cardId"] = this.cardId;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["turnoverId"] = this.turnoverId;
        data["turnover"] = this.turnover ? this.turnover.toJSON() : <any>undefined;
        data["exclusionId"] = this.exclusionId;
        data["exclusion"] = this.exclusion ? this.exclusion.toJSON() : <any>undefined;
        data["shotId"] = this.shotId;
        data["shot"] = this.shot ? this.shot.toJSON() : <any>undefined;
        data["challengeId"] = this.challengeId;
        data["challenge"] = this.challenge ? this.challenge.toJSON() : <any>undefined;
        data["goalkeeperChangeId"] = this.goalkeeperChangeId;
        data["goalkeeperChange"] = this.goalkeeperChange ? this.goalkeeperChange.toJSON() : <any>undefined;
        data["activeHomeGoalkeeperMatchPlayerId"] = this.activeHomeGoalkeeperMatchPlayerId;
        data["activeAwayGoalkeeperMatchPlayerId"] = this.activeAwayGoalkeeperMatchPlayerId;
        data["refereeMistake"] = this.refereeMistake;
        return data;
    }
}

export interface IEventVm {
    id: number;
    periodId: EventPeriodEnum;
    period: string;
    minute: number;
    seconds: number;
    matchId: number;
    match: MatchVm;
    typeId: EventTypeEnum;
    type: string;
    timeoutId: number | undefined;
    timeout: EventTimeoutVm | undefined;
    swimoffId: number | undefined;
    swimoff: EventSwimoffVm | undefined;
    cardId: number | undefined;
    card: EventCardVm | undefined;
    turnoverId: number | undefined;
    turnover: EventTurnoverVm | undefined;
    exclusionId: number | undefined;
    exclusion: EventExclusionVm | undefined;
    shotId: number | undefined;
    shot: EventShotVm | undefined;
    challengeId: number | undefined;
    challenge: EventChallengeVm | undefined;
    goalkeeperChangeId: number | undefined;
    goalkeeperChange: EventGoalkeeperChangeVm | undefined;
    activeHomeGoalkeeperMatchPlayerId: number | undefined;
    activeAwayGoalkeeperMatchPlayerId: number | undefined;
    refereeMistake: number | undefined;
}

export enum EventPeriodEnum {
    First_Period = 1200,
    Second_Period = 1201,
    Third_Period = 1202,
    Fourth_Period = 1203,
    Overtime = 1204,
}

export enum EventTypeEnum {
    Timeout = 700,
    Swim_Off = 701,
    Card = 702,
    Turnover = 703,
    Exclusion = 704,
    Shot = 705,
    Challenge = 706,
    Goalkeeper_Change = 707,
}

export class EventTimeoutVm implements IEventTimeoutVm {
    id!: number;
    teamId!: number;
    team!: TeamVm;

    constructor(data?: IEventTimeoutVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventTimeoutVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventTimeoutVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventTimeoutVm {
    id: number;
    teamId: number;
    team: TeamVm;
}

export class EventSwimoffVm implements IEventSwimoffVm {
    id!: number;
    homeTeamSwimmerId!: number;
    homeTeamSwimmer!: EventMatchPlayerVm;
    awayTeamSwimmerId!: number;
    awayTeamSwimmer!: EventMatchPlayerVm;
    winnerTeamId!: number | undefined;
    winnerTeam!: TeamVm | undefined;
    winnerSwimmerId!: number | undefined;
    winnerSwimmer!: EventMatchPlayerVm | undefined;

    constructor(data?: IEventSwimoffVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.homeTeamSwimmerId = _data["homeTeamSwimmerId"];
            this.homeTeamSwimmer = _data["homeTeamSwimmer"] ? EventMatchPlayerVm.fromJS(_data["homeTeamSwimmer"]) : <any>undefined;
            this.awayTeamSwimmerId = _data["awayTeamSwimmerId"];
            this.awayTeamSwimmer = _data["awayTeamSwimmer"] ? EventMatchPlayerVm.fromJS(_data["awayTeamSwimmer"]) : <any>undefined;
            this.winnerTeamId = _data["winnerTeamId"];
            this.winnerTeam = _data["winnerTeam"] ? TeamVm.fromJS(_data["winnerTeam"]) : <any>undefined;
            this.winnerSwimmerId = _data["winnerSwimmerId"];
            this.winnerSwimmer = _data["winnerSwimmer"] ? EventMatchPlayerVm.fromJS(_data["winnerSwimmer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventSwimoffVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventSwimoffVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeTeamSwimmerId"] = this.homeTeamSwimmerId;
        data["homeTeamSwimmer"] = this.homeTeamSwimmer ? this.homeTeamSwimmer.toJSON() : <any>undefined;
        data["awayTeamSwimmerId"] = this.awayTeamSwimmerId;
        data["awayTeamSwimmer"] = this.awayTeamSwimmer ? this.awayTeamSwimmer.toJSON() : <any>undefined;
        data["winnerTeamId"] = this.winnerTeamId;
        data["winnerTeam"] = this.winnerTeam ? this.winnerTeam.toJSON() : <any>undefined;
        data["winnerSwimmerId"] = this.winnerSwimmerId;
        data["winnerSwimmer"] = this.winnerSwimmer ? this.winnerSwimmer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventSwimoffVm {
    id: number;
    homeTeamSwimmerId: number;
    homeTeamSwimmer: EventMatchPlayerVm;
    awayTeamSwimmerId: number;
    awayTeamSwimmer: EventMatchPlayerVm;
    winnerTeamId: number | undefined;
    winnerTeam: TeamVm | undefined;
    winnerSwimmerId: number | undefined;
    winnerSwimmer: EventMatchPlayerVm | undefined;
}

export class EventMatchPlayerVm implements IEventMatchPlayerVm {
    id!: number | undefined;
    number!: number;
    capNumber!: number;
    matchId!: number;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum;

    constructor(data?: IEventMatchPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.capNumber = _data["capNumber"];
            this.matchId = _data["matchId"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
        }
    }

    static fromJS(data: any): EventMatchPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventMatchPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["capNumber"] = this.capNumber;
        data["matchId"] = this.matchId;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        return data;
    }
}

export interface IEventMatchPlayerVm {
    id: number | undefined;
    number: number;
    capNumber: number;
    matchId: number;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum;
}

export class EventCardVm implements IEventCardVm {
    id!: number;
    teamId!: number;
    team!: TeamVm;
    typeId!: CardTypeEnum;
    type!: string;
    cardedPlayerId!: number | undefined;
    cardedPlayer!: EventMatchPlayerVm | undefined;
    cardedCoachId!: number | undefined;
    cardedCoach!: EventMatchCoachVm | undefined;

    constructor(data?: IEventCardVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.cardedPlayerId = _data["cardedPlayerId"];
            this.cardedPlayer = _data["cardedPlayer"] ? EventMatchPlayerVm.fromJS(_data["cardedPlayer"]) : <any>undefined;
            this.cardedCoachId = _data["cardedCoachId"];
            this.cardedCoach = _data["cardedCoach"] ? EventMatchCoachVm.fromJS(_data["cardedCoach"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventCardVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventCardVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["cardedPlayerId"] = this.cardedPlayerId;
        data["cardedPlayer"] = this.cardedPlayer ? this.cardedPlayer.toJSON() : <any>undefined;
        data["cardedCoachId"] = this.cardedCoachId;
        data["cardedCoach"] = this.cardedCoach ? this.cardedCoach.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventCardVm {
    id: number;
    teamId: number;
    team: TeamVm;
    typeId: CardTypeEnum;
    type: string;
    cardedPlayerId: number | undefined;
    cardedPlayer: EventMatchPlayerVm | undefined;
    cardedCoachId: number | undefined;
    cardedCoach: EventMatchCoachVm | undefined;
}

export enum CardTypeEnum {
    Yellow = 800,
    Red = 801,
}

export class EventMatchCoachVm implements IEventMatchCoachVm {
    id!: number | undefined;
    matchId!: number;
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;

    constructor(data?: IEventMatchCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): EventMatchCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventMatchCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IEventMatchCoachVm {
    id: number | undefined;
    matchId: number;
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
}

export class EventTurnoverVm implements IEventTurnoverVm {
    id!: number;
    teamId!: number;
    team!: TeamVm;
    typeId!: TurnoverTypeEnum;
    type!: string;
    lostPossesionPlayerId!: number;
    lostPossesionPlayer!: EventMatchPlayerVm;
    wonPossesionPlayerId!: number | undefined;
    wonPossesionPlayer!: EventMatchPlayerVm | undefined;

    constructor(data?: IEventTurnoverVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.lostPossesionPlayerId = _data["lostPossesionPlayerId"];
            this.lostPossesionPlayer = _data["lostPossesionPlayer"] ? EventMatchPlayerVm.fromJS(_data["lostPossesionPlayer"]) : <any>undefined;
            this.wonPossesionPlayerId = _data["wonPossesionPlayerId"];
            this.wonPossesionPlayer = _data["wonPossesionPlayer"] ? EventMatchPlayerVm.fromJS(_data["wonPossesionPlayer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventTurnoverVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventTurnoverVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["lostPossesionPlayerId"] = this.lostPossesionPlayerId;
        data["lostPossesionPlayer"] = this.lostPossesionPlayer ? this.lostPossesionPlayer.toJSON() : <any>undefined;
        data["wonPossesionPlayerId"] = this.wonPossesionPlayerId;
        data["wonPossesionPlayer"] = this.wonPossesionPlayer ? this.wonPossesionPlayer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventTurnoverVm {
    id: number;
    teamId: number;
    team: TeamVm;
    typeId: TurnoverTypeEnum;
    type: string;
    lostPossesionPlayerId: number;
    lostPossesionPlayer: EventMatchPlayerVm;
    wonPossesionPlayerId: number | undefined;
    wonPossesionPlayer: EventMatchPlayerVm | undefined;
}

export enum TurnoverTypeEnum {
    Lost_Ball = 900,
    Offensive_Foul = 901,
    Ball_Under = 902,
    Clock_Expired = 903,
}

export class EventExclusionVm implements IEventExclusionVm {
    id!: number;
    teamId!: number;
    team!: TeamVm;
    typeId!: ExclusionTypeEnum;
    type!: string;
    excludedPlayerId!: number | undefined;
    excludedPlayer!: EventMatchPlayerVm | undefined;
    excludedCoachId!: number | undefined;
    excludedCoach!: EventMatchCoachVm | undefined;
    fouledPlayerId!: number | undefined;
    fouledPlayer!: EventMatchPlayerVm | undefined;
    assistedById!: number | undefined;
    assistedBy!: EventMatchPlayerVm | undefined;
    isPenaltyExclusion!: boolean;
    isDoubleExclusion!: boolean;
    locationX!: number | undefined;
    locationY!: number | undefined;

    constructor(data?: IEventExclusionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.excludedPlayerId = _data["excludedPlayerId"];
            this.excludedPlayer = _data["excludedPlayer"] ? EventMatchPlayerVm.fromJS(_data["excludedPlayer"]) : <any>undefined;
            this.excludedCoachId = _data["excludedCoachId"];
            this.excludedCoach = _data["excludedCoach"] ? EventMatchCoachVm.fromJS(_data["excludedCoach"]) : <any>undefined;
            this.fouledPlayerId = _data["fouledPlayerId"];
            this.fouledPlayer = _data["fouledPlayer"] ? EventMatchPlayerVm.fromJS(_data["fouledPlayer"]) : <any>undefined;
            this.assistedById = _data["assistedById"];
            this.assistedBy = _data["assistedBy"] ? EventMatchPlayerVm.fromJS(_data["assistedBy"]) : <any>undefined;
            this.isPenaltyExclusion = _data["isPenaltyExclusion"];
            this.isDoubleExclusion = _data["isDoubleExclusion"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
        }
    }

    static fromJS(data: any): EventExclusionVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventExclusionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["excludedPlayerId"] = this.excludedPlayerId;
        data["excludedPlayer"] = this.excludedPlayer ? this.excludedPlayer.toJSON() : <any>undefined;
        data["excludedCoachId"] = this.excludedCoachId;
        data["excludedCoach"] = this.excludedCoach ? this.excludedCoach.toJSON() : <any>undefined;
        data["fouledPlayerId"] = this.fouledPlayerId;
        data["fouledPlayer"] = this.fouledPlayer ? this.fouledPlayer.toJSON() : <any>undefined;
        data["assistedById"] = this.assistedById;
        data["assistedBy"] = this.assistedBy ? this.assistedBy.toJSON() : <any>undefined;
        data["isPenaltyExclusion"] = this.isPenaltyExclusion;
        data["isDoubleExclusion"] = this.isDoubleExclusion;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        return data;
    }
}

export interface IEventExclusionVm {
    id: number;
    teamId: number;
    team: TeamVm;
    typeId: ExclusionTypeEnum;
    type: string;
    excludedPlayerId: number | undefined;
    excludedPlayer: EventMatchPlayerVm | undefined;
    excludedCoachId: number | undefined;
    excludedCoach: EventMatchCoachVm | undefined;
    fouledPlayerId: number | undefined;
    fouledPlayer: EventMatchPlayerVm | undefined;
    assistedById: number | undefined;
    assistedBy: EventMatchPlayerVm | undefined;
    isPenaltyExclusion: boolean;
    isDoubleExclusion: boolean;
    locationX: number | undefined;
    locationY: number | undefined;
}

export enum ExclusionTypeEnum {
    Exclusion = 1000,
    Suspension = 1001,
    Brutality = 1002,
    Penalty = 1003,
}

export class EventShotVm implements IEventShotVm {
    id!: number;
    teamId!: number;
    team!: TeamVm;
    typeId!: ShotTypeEnum;
    type!: string;
    takenById!: number;
    takenBy!: EventMatchPlayerVm;
    blockedById!: number | undefined;
    blockedBy!: EventMatchPlayerVm | undefined;
    assistedById!: number | undefined;
    assistedBy!: EventMatchPlayerVm | undefined;
    savedById!: number | undefined;
    savedBy!: EventMatchPlayerVm | undefined;
    isGoal!: boolean;
    isFastBreak!: boolean;
    isDirectFromFoul!: boolean;
    shotTechnique!: number | undefined;
    fakeCount!: number;
    locationX!: number | undefined;
    locationY!: number | undefined;
    targetX!: number | undefined;
    targetY!: number | undefined;

    constructor(data?: IEventShotVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.takenById = _data["takenById"];
            this.takenBy = _data["takenBy"] ? EventMatchPlayerVm.fromJS(_data["takenBy"]) : <any>undefined;
            this.blockedById = _data["blockedById"];
            this.blockedBy = _data["blockedBy"] ? EventMatchPlayerVm.fromJS(_data["blockedBy"]) : <any>undefined;
            this.assistedById = _data["assistedById"];
            this.assistedBy = _data["assistedBy"] ? EventMatchPlayerVm.fromJS(_data["assistedBy"]) : <any>undefined;
            this.savedById = _data["savedById"];
            this.savedBy = _data["savedBy"] ? EventMatchPlayerVm.fromJS(_data["savedBy"]) : <any>undefined;
            this.isGoal = _data["isGoal"];
            this.isFastBreak = _data["isFastBreak"];
            this.isDirectFromFoul = _data["isDirectFromFoul"];
            this.shotTechnique = _data["shotTechnique"];
            this.fakeCount = _data["fakeCount"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
            this.targetX = _data["targetX"];
            this.targetY = _data["targetY"];
        }
    }

    static fromJS(data: any): EventShotVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventShotVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["takenById"] = this.takenById;
        data["takenBy"] = this.takenBy ? this.takenBy.toJSON() : <any>undefined;
        data["blockedById"] = this.blockedById;
        data["blockedBy"] = this.blockedBy ? this.blockedBy.toJSON() : <any>undefined;
        data["assistedById"] = this.assistedById;
        data["assistedBy"] = this.assistedBy ? this.assistedBy.toJSON() : <any>undefined;
        data["savedById"] = this.savedById;
        data["savedBy"] = this.savedBy ? this.savedBy.toJSON() : <any>undefined;
        data["isGoal"] = this.isGoal;
        data["isFastBreak"] = this.isFastBreak;
        data["isDirectFromFoul"] = this.isDirectFromFoul;
        data["shotTechnique"] = this.shotTechnique;
        data["fakeCount"] = this.fakeCount;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        data["targetX"] = this.targetX;
        data["targetY"] = this.targetY;
        return data;
    }
}

export interface IEventShotVm {
    id: number;
    teamId: number;
    team: TeamVm;
    typeId: ShotTypeEnum;
    type: string;
    takenById: number;
    takenBy: EventMatchPlayerVm;
    blockedById: number | undefined;
    blockedBy: EventMatchPlayerVm | undefined;
    assistedById: number | undefined;
    assistedBy: EventMatchPlayerVm | undefined;
    savedById: number | undefined;
    savedBy: EventMatchPlayerVm | undefined;
    isGoal: boolean;
    isFastBreak: boolean;
    isDirectFromFoul: boolean;
    shotTechnique: number | undefined;
    fakeCount: number;
    locationX: number | undefined;
    locationY: number | undefined;
    targetX: number | undefined;
    targetY: number | undefined;
}

export enum ShotTypeEnum {
    Regular_Attack = 1100,
    Penalty = 1101,
    Power_Play = 1102,
    Penalty_Shootout = 1103,
}

export class EventChallengeVm implements IEventChallengeVm {
    id!: number;
    teamId!: number;
    isSuccessful!: boolean;
    team!: TeamVm;

    constructor(data?: IEventChallengeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.isSuccessful = _data["isSuccessful"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventChallengeVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventChallengeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["isSuccessful"] = this.isSuccessful;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventChallengeVm {
    id: number;
    teamId: number;
    isSuccessful: boolean;
    team: TeamVm;
}

export class EventGoalkeeperChangeVm implements IEventGoalkeeperChangeVm {
    id!: number;
    teamId!: number;
    newGoalkeeperMatchPlayerId!: number;
    previousGoalkeeperMatchPlayerId!: number | undefined;

    constructor(data?: IEventGoalkeeperChangeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.newGoalkeeperMatchPlayerId = _data["newGoalkeeperMatchPlayerId"];
            this.previousGoalkeeperMatchPlayerId = _data["previousGoalkeeperMatchPlayerId"];
        }
    }

    static fromJS(data: any): EventGoalkeeperChangeVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventGoalkeeperChangeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["newGoalkeeperMatchPlayerId"] = this.newGoalkeeperMatchPlayerId;
        data["previousGoalkeeperMatchPlayerId"] = this.previousGoalkeeperMatchPlayerId;
        return data;
    }
}

export interface IEventGoalkeeperChangeVm {
    id: number;
    teamId: number;
    newGoalkeeperMatchPlayerId: number;
    previousGoalkeeperMatchPlayerId: number | undefined;
}

export class CreateEventCommand implements ICreateEventCommand {
    matchId!: number;
    typeId!: EventTypeEnum;
    periodId!: EventPeriodEnum;
    minute!: number;
    seconds!: number;
    card!: CardRequest;
    exclusion!: ExclusionRequest;
    shot!: ShotRequest;
    swimoff!: SwimoffRequest;
    timeout!: TimeoutRequest;
    challenge!: ChallengeRequest;
    turnover!: TurnoverRequest;
    goalkeeperChange!: GoalkeeperChangeRequest | undefined;
    activeHomeGoalkeeperMatchPlayerId!: number | undefined;
    activeAwayGoalkeeperMatchPlayerId!: number | undefined;
    refereeMistake!: number | undefined;

    constructor(data?: ICreateEventCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.card = new CardRequest();
            this.exclusion = new ExclusionRequest();
            this.shot = new ShotRequest();
            this.swimoff = new SwimoffRequest();
            this.timeout = new TimeoutRequest();
            this.challenge = new ChallengeRequest();
            this.turnover = new TurnoverRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.typeId = _data["typeId"];
            this.periodId = _data["periodId"];
            this.minute = _data["minute"];
            this.seconds = _data["seconds"];
            this.card = _data["card"] ? CardRequest.fromJS(_data["card"]) : new CardRequest();
            this.exclusion = _data["exclusion"] ? ExclusionRequest.fromJS(_data["exclusion"]) : new ExclusionRequest();
            this.shot = _data["shot"] ? ShotRequest.fromJS(_data["shot"]) : new ShotRequest();
            this.swimoff = _data["swimoff"] ? SwimoffRequest.fromJS(_data["swimoff"]) : new SwimoffRequest();
            this.timeout = _data["timeout"] ? TimeoutRequest.fromJS(_data["timeout"]) : new TimeoutRequest();
            this.challenge = _data["challenge"] ? ChallengeRequest.fromJS(_data["challenge"]) : new ChallengeRequest();
            this.turnover = _data["turnover"] ? TurnoverRequest.fromJS(_data["turnover"]) : new TurnoverRequest();
            this.goalkeeperChange = _data["goalkeeperChange"] ? GoalkeeperChangeRequest.fromJS(_data["goalkeeperChange"]) : <any>undefined;
            this.activeHomeGoalkeeperMatchPlayerId = _data["activeHomeGoalkeeperMatchPlayerId"];
            this.activeAwayGoalkeeperMatchPlayerId = _data["activeAwayGoalkeeperMatchPlayerId"];
            this.refereeMistake = _data["refereeMistake"];
        }
    }

    static fromJS(data: any): CreateEventCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEventCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["typeId"] = this.typeId;
        data["periodId"] = this.periodId;
        data["minute"] = this.minute;
        data["seconds"] = this.seconds;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["exclusion"] = this.exclusion ? this.exclusion.toJSON() : <any>undefined;
        data["shot"] = this.shot ? this.shot.toJSON() : <any>undefined;
        data["swimoff"] = this.swimoff ? this.swimoff.toJSON() : <any>undefined;
        data["timeout"] = this.timeout ? this.timeout.toJSON() : <any>undefined;
        data["challenge"] = this.challenge ? this.challenge.toJSON() : <any>undefined;
        data["turnover"] = this.turnover ? this.turnover.toJSON() : <any>undefined;
        data["goalkeeperChange"] = this.goalkeeperChange ? this.goalkeeperChange.toJSON() : <any>undefined;
        data["activeHomeGoalkeeperMatchPlayerId"] = this.activeHomeGoalkeeperMatchPlayerId;
        data["activeAwayGoalkeeperMatchPlayerId"] = this.activeAwayGoalkeeperMatchPlayerId;
        data["refereeMistake"] = this.refereeMistake;
        return data;
    }
}

export interface ICreateEventCommand {
    matchId: number;
    typeId: EventTypeEnum;
    periodId: EventPeriodEnum;
    minute: number;
    seconds: number;
    card: CardRequest;
    exclusion: ExclusionRequest;
    shot: ShotRequest;
    swimoff: SwimoffRequest;
    timeout: TimeoutRequest;
    challenge: ChallengeRequest;
    turnover: TurnoverRequest;
    goalkeeperChange: GoalkeeperChangeRequest | undefined;
    activeHomeGoalkeeperMatchPlayerId: number | undefined;
    activeAwayGoalkeeperMatchPlayerId: number | undefined;
    refereeMistake: number | undefined;
}

export class CardRequest implements ICardRequest {
    id!: number;
    teamId!: number;
    typeId!: CardTypeEnum;
    cardedPlayerId!: number | undefined;
    cardedCoachId!: number | undefined;

    constructor(data?: ICardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.typeId = _data["typeId"];
            this.cardedPlayerId = _data["cardedPlayerId"];
            this.cardedCoachId = _data["cardedCoachId"];
        }
    }

    static fromJS(data: any): CardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["typeId"] = this.typeId;
        data["cardedPlayerId"] = this.cardedPlayerId;
        data["cardedCoachId"] = this.cardedCoachId;
        return data;
    }
}

export interface ICardRequest {
    id: number;
    teamId: number;
    typeId: CardTypeEnum;
    cardedPlayerId: number | undefined;
    cardedCoachId: number | undefined;
}

export class ExclusionRequest implements IExclusionRequest {
    id!: number;
    teamId!: number;
    typeId!: ExclusionTypeEnum;
    excludedPlayerId!: number | undefined;
    excludedCoachId!: number | undefined;
    fouledPlayerId!: number | undefined;
    assistedById!: number | undefined;
    isPenaltyExclusion!: boolean;
    isDoubleExclusion!: boolean;
    locationX!: number | undefined;
    locationY!: number | undefined;

    constructor(data?: IExclusionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.typeId = _data["typeId"];
            this.excludedPlayerId = _data["excludedPlayerId"];
            this.excludedCoachId = _data["excludedCoachId"];
            this.fouledPlayerId = _data["fouledPlayerId"];
            this.assistedById = _data["assistedById"];
            this.isPenaltyExclusion = _data["isPenaltyExclusion"];
            this.isDoubleExclusion = _data["isDoubleExclusion"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
        }
    }

    static fromJS(data: any): ExclusionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExclusionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["typeId"] = this.typeId;
        data["excludedPlayerId"] = this.excludedPlayerId;
        data["excludedCoachId"] = this.excludedCoachId;
        data["fouledPlayerId"] = this.fouledPlayerId;
        data["assistedById"] = this.assistedById;
        data["isPenaltyExclusion"] = this.isPenaltyExclusion;
        data["isDoubleExclusion"] = this.isDoubleExclusion;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        return data;
    }
}

export interface IExclusionRequest {
    id: number;
    teamId: number;
    typeId: ExclusionTypeEnum;
    excludedPlayerId: number | undefined;
    excludedCoachId: number | undefined;
    fouledPlayerId: number | undefined;
    assistedById: number | undefined;
    isPenaltyExclusion: boolean;
    isDoubleExclusion: boolean;
    locationX: number | undefined;
    locationY: number | undefined;
}

export class ShotRequest implements IShotRequest {
    id!: number;
    teamId!: number;
    typeId!: ShotTypeEnum;
    takenById!: number;
    blockedById!: number | undefined;
    assistedById!: number | undefined;
    savedById!: number | undefined;
    isGoal!: boolean;
    isFastBreak!: boolean;
    isDirectFromFoul!: boolean;
    shotTechnique!: number | undefined;
    fakeCount!: number;
    locationX!: number | undefined;
    locationY!: number | undefined;
    targetX!: number | undefined;
    targetY!: number | undefined;

    constructor(data?: IShotRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.typeId = _data["typeId"];
            this.takenById = _data["takenById"];
            this.blockedById = _data["blockedById"];
            this.assistedById = _data["assistedById"];
            this.savedById = _data["savedById"];
            this.isGoal = _data["isGoal"];
            this.isFastBreak = _data["isFastBreak"];
            this.isDirectFromFoul = _data["isDirectFromFoul"];
            this.shotTechnique = _data["shotTechnique"];
            this.fakeCount = _data["fakeCount"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
            this.targetX = _data["targetX"];
            this.targetY = _data["targetY"];
        }
    }

    static fromJS(data: any): ShotRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShotRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["typeId"] = this.typeId;
        data["takenById"] = this.takenById;
        data["blockedById"] = this.blockedById;
        data["assistedById"] = this.assistedById;
        data["savedById"] = this.savedById;
        data["isGoal"] = this.isGoal;
        data["isFastBreak"] = this.isFastBreak;
        data["isDirectFromFoul"] = this.isDirectFromFoul;
        data["shotTechnique"] = this.shotTechnique;
        data["fakeCount"] = this.fakeCount;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        data["targetX"] = this.targetX;
        data["targetY"] = this.targetY;
        return data;
    }
}

export interface IShotRequest {
    id: number;
    teamId: number;
    typeId: ShotTypeEnum;
    takenById: number;
    blockedById: number | undefined;
    assistedById: number | undefined;
    savedById: number | undefined;
    isGoal: boolean;
    isFastBreak: boolean;
    isDirectFromFoul: boolean;
    shotTechnique: number | undefined;
    fakeCount: number;
    locationX: number | undefined;
    locationY: number | undefined;
    targetX: number | undefined;
    targetY: number | undefined;
}

export class SwimoffRequest implements ISwimoffRequest {
    id!: number;
    homeTeamSwimmerId!: number;
    awayTeamSwimmerId!: number;
    winnerTeamId!: number | undefined;
    winnerSwimmerId!: number | undefined;

    constructor(data?: ISwimoffRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.homeTeamSwimmerId = _data["homeTeamSwimmerId"];
            this.awayTeamSwimmerId = _data["awayTeamSwimmerId"];
            this.winnerTeamId = _data["winnerTeamId"];
            this.winnerSwimmerId = _data["winnerSwimmerId"];
        }
    }

    static fromJS(data: any): SwimoffRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwimoffRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeTeamSwimmerId"] = this.homeTeamSwimmerId;
        data["awayTeamSwimmerId"] = this.awayTeamSwimmerId;
        data["winnerTeamId"] = this.winnerTeamId;
        data["winnerSwimmerId"] = this.winnerSwimmerId;
        return data;
    }
}

export interface ISwimoffRequest {
    id: number;
    homeTeamSwimmerId: number;
    awayTeamSwimmerId: number;
    winnerTeamId: number | undefined;
    winnerSwimmerId: number | undefined;
}

export class TimeoutRequest implements ITimeoutRequest {
    id!: number;
    teamId!: number;

    constructor(data?: ITimeoutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
        }
    }

    static fromJS(data: any): TimeoutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TimeoutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        return data;
    }
}

export interface ITimeoutRequest {
    id: number;
    teamId: number;
}

export class ChallengeRequest implements IChallengeRequest {
    id!: number;
    teamId!: number;
    isSuccessful!: boolean;

    constructor(data?: IChallengeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any): ChallengeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface IChallengeRequest {
    id: number;
    teamId: number;
    isSuccessful: boolean;
}

export class TurnoverRequest implements ITurnoverRequest {
    id!: number;
    teamId!: number;
    typeId!: TurnoverTypeEnum;
    lostPossesionPlayerId!: number;
    wonPossesionPlayerId!: number | undefined;

    constructor(data?: ITurnoverRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.typeId = _data["typeId"];
            this.lostPossesionPlayerId = _data["lostPossesionPlayerId"];
            this.wonPossesionPlayerId = _data["wonPossesionPlayerId"];
        }
    }

    static fromJS(data: any): TurnoverRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["typeId"] = this.typeId;
        data["lostPossesionPlayerId"] = this.lostPossesionPlayerId;
        data["wonPossesionPlayerId"] = this.wonPossesionPlayerId;
        return data;
    }
}

export interface ITurnoverRequest {
    id: number;
    teamId: number;
    typeId: TurnoverTypeEnum;
    lostPossesionPlayerId: number;
    wonPossesionPlayerId: number | undefined;
}

export class GoalkeeperChangeRequest implements IGoalkeeperChangeRequest {
    id!: number;
    teamId!: number;
    newGoalkeeperMatchPlayerId!: number;
    previousGoalkeeperMatchPlayerId!: number | undefined;

    constructor(data?: IGoalkeeperChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.newGoalkeeperMatchPlayerId = _data["newGoalkeeperMatchPlayerId"];
            this.previousGoalkeeperMatchPlayerId = _data["previousGoalkeeperMatchPlayerId"];
        }
    }

    static fromJS(data: any): GoalkeeperChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GoalkeeperChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["newGoalkeeperMatchPlayerId"] = this.newGoalkeeperMatchPlayerId;
        data["previousGoalkeeperMatchPlayerId"] = this.previousGoalkeeperMatchPlayerId;
        return data;
    }
}

export interface IGoalkeeperChangeRequest {
    id: number;
    teamId: number;
    newGoalkeeperMatchPlayerId: number;
    previousGoalkeeperMatchPlayerId: number | undefined;
}

export class UpdateEventCommand extends CreateEventCommand implements IUpdateEventCommand {
    id!: number;

    constructor(data?: IUpdateEventCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEventCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEventCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateEventCommand extends ICreateEventCommand {
    id: number;
}

export class FederationOfficialVm implements IFederationOfficialVm {
    id!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    officialId!: number;
    official!: OfficialVm;
    federationId!: number;
    federation!: string;
    roles!: FederationOfficialRoleVm[];

    constructor(data?: IFederationOfficialVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.officialId = _data["officialId"];
            this.official = _data["official"] ? OfficialVm.fromJS(_data["official"]) : <any>undefined;
            this.federationId = _data["federationId"];
            this.federation = _data["federation"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(FederationOfficialRoleVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FederationOfficialVm {
        data = typeof data === 'object' ? data : {};
        let result = new FederationOfficialVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["officialId"] = this.officialId;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["federationId"] = this.federationId;
        data["federation"] = this.federation;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFederationOfficialVm {
    id: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    officialId: number;
    official: OfficialVm;
    federationId: number;
    federation: string;
    roles: FederationOfficialRoleVm[];
}

export class FederationOfficialRoleVm implements IFederationOfficialRoleVm {
    id!: number;
    roleId!: OfficialRoleEnum;
    role!: string;

    constructor(data?: IFederationOfficialRoleVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): FederationOfficialRoleVm {
        data = typeof data === 'object' ? data : {};
        let result = new FederationOfficialRoleVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["role"] = this.role;
        return data;
    }
}

export interface IFederationOfficialRoleVm {
    id: number;
    roleId: OfficialRoleEnum;
    role: string;
}

export enum OfficialRoleEnum {
    Referee = 600,
    Delegate = 601,
    Secretary = 602,
    Timekeeper = 603,
    Director = 604,
    Goal_Referee = 605,
    VAR = 606,
}

export class CreateFederationOfficialCommandOfFederationOfficial implements ICreateFederationOfficialCommandOfFederationOfficial {
    federationId!: number;
    officialId!: number;
    roles!: OfficialRoleEnum[];
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;

    constructor(data?: ICreateFederationOfficialCommandOfFederationOfficial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.federationId = _data["federationId"];
            this.officialId = _data["officialId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFederationOfficialCommandOfFederationOfficial {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFederationOfficialCommandOfFederationOfficial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["federationId"] = this.federationId;
        data["officialId"] = this.officialId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateFederationOfficialCommandOfFederationOfficial {
    federationId: number;
    officialId: number;
    roles: OfficialRoleEnum[];
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
}

export class UpdateFederationOfficialCommand implements IUpdateFederationOfficialCommand {
    id!: number;
    roles!: OfficialRoleEnum[] | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;

    constructor(data?: IUpdateFederationOfficialCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateFederationOfficialCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFederationOfficialCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateFederationOfficialCommand {
    id: number;
    roles: OfficialRoleEnum[] | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
}

export class FederationVm implements IFederationVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date;
    activeTo!: Date | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    president!: string | undefined;
    secretary!: string | undefined;
    isPro!: boolean;
    countryId!: number;
    country!: string;
    cityId!: number | undefined;
    city!: string | undefined;

    constructor(data?: IFederationVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.president = _data["president"];
            this.secretary = _data["secretary"];
            this.isPro = _data["isPro"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): FederationVm {
        data = typeof data === 'object' ? data : {};
        let result = new FederationVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["president"] = this.president;
        data["secretary"] = this.secretary;
        data["isPro"] = this.isPro;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        return data;
    }
}

export interface IFederationVm {
    id: number;
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date;
    activeTo: Date | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    president: string | undefined;
    secretary: string | undefined;
    isPro: boolean;
    countryId: number;
    country: string;
    cityId: number | undefined;
    city: string | undefined;
}

export class PaginatedListOfFederationVm implements IPaginatedListOfFederationVm {
    pageItems!: FederationVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfFederationVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(FederationVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfFederationVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfFederationVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfFederationVm {
    pageItems: FederationVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class FederationDetailVm extends FederationVm implements IFederationDetailVm {
    logo!: string | undefined;
    clubs!: ClubVm[];
    competitions!: CompetitionVm[];
    officials!: FederationOfficialVm[];
    categories!: FederationCategoryVm[];

    constructor(data?: IFederationDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logo = _data["logo"];
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(ClubVm.fromJS(item));
            }
            if (Array.isArray(_data["competitions"])) {
                this.competitions = [] as any;
                for (let item of _data["competitions"])
                    this.competitions!.push(CompetitionVm.fromJS(item));
            }
            if (Array.isArray(_data["officials"])) {
                this.officials = [] as any;
                for (let item of _data["officials"])
                    this.officials!.push(FederationOfficialVm.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(FederationCategoryVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FederationDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new FederationDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        if (Array.isArray(this.competitions)) {
            data["competitions"] = [];
            for (let item of this.competitions)
                data["competitions"].push(item.toJSON());
        }
        if (Array.isArray(this.officials)) {
            data["officials"] = [];
            for (let item of this.officials)
                data["officials"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFederationDetailVm extends IFederationVm {
    logo: string | undefined;
    clubs: ClubVm[];
    competitions: CompetitionVm[];
    officials: FederationOfficialVm[];
    categories: FederationCategoryVm[];
}

export class FederationCategoryVm implements IFederationCategoryVm {
    id!: number;
    federationId!: number;
    federation!: string;
    categoryId!: number;
    category!: string;

    constructor(data?: IFederationCategoryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.federationId = _data["federationId"];
            this.federation = _data["federation"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): FederationCategoryVm {
        data = typeof data === 'object' ? data : {};
        let result = new FederationCategoryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["federationId"] = this.federationId;
        data["federation"] = this.federation;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        return data;
    }
}

export interface IFederationCategoryVm {
    id: number;
    federationId: number;
    federation: string;
    categoryId: number;
    category: string;
}

export class CreateFederationCommandOfFederation implements ICreateFederationCommandOfFederation {
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date;
    activeTo!: Date | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    president!: string | undefined;
    secretary!: string | undefined;
    logo!: string | undefined;
    isPro!: boolean;
    countryId!: number;
    cityId!: number | undefined;
    categories!: number[] | undefined;

    constructor(data?: ICreateFederationCommandOfFederation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.president = _data["president"];
            this.secretary = _data["secretary"];
            this.logo = _data["logo"];
            this.isPro = _data["isPro"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateFederationCommandOfFederation {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFederationCommandOfFederation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["president"] = this.president;
        data["secretary"] = this.secretary;
        data["logo"] = this.logo;
        data["isPro"] = this.isPro;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        return data;
    }
}

export interface ICreateFederationCommandOfFederation {
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date;
    activeTo: Date | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    president: string | undefined;
    secretary: string | undefined;
    logo: string | undefined;
    isPro: boolean;
    countryId: number;
    cityId: number | undefined;
    categories: number[] | undefined;
}

export class UpdateFederationCommand extends CreateFederationCommandOfFederation implements IUpdateFederationCommand {
    id!: number;

    constructor(data?: IUpdateFederationCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFederationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFederationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateFederationCommand extends ICreateFederationCommandOfFederation {
    id: number;
}

export class CreateMatchCoachCommandOfMatchCoach implements ICreateMatchCoachCommandOfMatchCoach {
    id!: number;
    matchId!: number;
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;

    constructor(data?: ICreateMatchCoachCommandOfMatchCoach) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): CreateMatchCoachCommandOfMatchCoach {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchCoachCommandOfMatchCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ICreateMatchCoachCommandOfMatchCoach {
    id: number;
    matchId: number;
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
}

export class UpdateMatchCoachCommandOfMatchCoach extends CreateMatchCoachCommandOfMatchCoach implements IUpdateMatchCoachCommandOfMatchCoach {

    constructor(data?: IUpdateMatchCoachCommandOfMatchCoach) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateMatchCoachCommandOfMatchCoach {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchCoachCommandOfMatchCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMatchCoachCommandOfMatchCoach extends ICreateMatchCoachCommandOfMatchCoach {
}

export class PaginatedListOfMatchVm implements IPaginatedListOfMatchVm {
    pageItems!: MatchVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfMatchVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(MatchVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfMatchVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfMatchVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfMatchVm {
    pageItems: MatchVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class PaginationFilterOfMatchFilter implements IPaginationFilterOfMatchFilter {
    filter!: MatchFilter | undefined;
    pageIndex!: number | undefined;
    pageSize!: number | undefined;
    sortBy!: string | undefined;
    sortOrder!: string | undefined;

    constructor(data?: IPaginationFilterOfMatchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? MatchFilter.fromJS(_data["filter"]) : <any>undefined;
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortBy = _data["sortBy"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): PaginationFilterOfMatchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationFilterOfMatchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortBy"] = this.sortBy;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IPaginationFilterOfMatchFilter {
    filter: MatchFilter | undefined;
    pageIndex: number | undefined;
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortOrder: string | undefined;
}

export class MatchFilter implements IMatchFilter {
    homeTeamDisplayName!: string | undefined;
    awayTeamDisplayName!: string | undefined;
    competitionId!: number | undefined;
    id!: number | undefined;
    venue!: string | undefined;
    round!: string | undefined;
    status!: string | undefined;
    startDate!: FilterItemOfDateTime[] | undefined;

    constructor(data?: IMatchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.homeTeamDisplayName = _data["homeTeamDisplayName"];
            this.awayTeamDisplayName = _data["awayTeamDisplayName"];
            this.competitionId = _data["competitionId"];
            this.id = _data["id"];
            this.venue = _data["venue"];
            this.round = _data["round"];
            this.status = _data["status"];
            if (Array.isArray(_data["startDate"])) {
                this.startDate = [] as any;
                for (let item of _data["startDate"])
                    this.startDate!.push(FilterItemOfDateTime.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MatchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MatchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeTeamDisplayName"] = this.homeTeamDisplayName;
        data["awayTeamDisplayName"] = this.awayTeamDisplayName;
        data["competitionId"] = this.competitionId;
        data["id"] = this.id;
        data["venue"] = this.venue;
        data["round"] = this.round;
        data["status"] = this.status;
        if (Array.isArray(this.startDate)) {
            data["startDate"] = [];
            for (let item of this.startDate)
                data["startDate"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMatchFilter {
    homeTeamDisplayName: string | undefined;
    awayTeamDisplayName: string | undefined;
    competitionId: number | undefined;
    id: number | undefined;
    venue: string | undefined;
    round: string | undefined;
    status: string | undefined;
    startDate: FilterItemOfDateTime[] | undefined;
}

export class FilterItemOfDateTime implements IFilterItemOfDateTime {
    value!: Date;
    operation!: string | undefined;

    constructor(data?: IFilterItemOfDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
            this.operation = _data["operation"];
        }
    }

    static fromJS(data: any): FilterItemOfDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new FilterItemOfDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        data["operation"] = this.operation;
        return data;
    }
}

export interface IFilterItemOfDateTime {
    value: Date;
    operation: string | undefined;
}

export class MatchDetailVm extends MatchVm implements IMatchDetailVm {
    competition!: CompetitionVm | undefined;
    homeTeam!: TeamVm | undefined;
    awayTeam!: TeamVm | undefined;
    competitionLogo!: string | undefined;
    federationLogo!: string | undefined;
    officials!: MatchOfficialVm[] | undefined;
    coaches!: MatchCoachVm[] | undefined;
    players!: MatchPlayerVm[] | undefined;

    constructor(data?: IMatchDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.competition = _data["competition"] ? CompetitionVm.fromJS(_data["competition"]) : <any>undefined;
            this.homeTeam = _data["homeTeam"] ? TeamVm.fromJS(_data["homeTeam"]) : <any>undefined;
            this.awayTeam = _data["awayTeam"] ? TeamVm.fromJS(_data["awayTeam"]) : <any>undefined;
            this.competitionLogo = _data["competitionLogo"];
            this.federationLogo = _data["federationLogo"];
            if (Array.isArray(_data["officials"])) {
                this.officials = [] as any;
                for (let item of _data["officials"])
                    this.officials!.push(MatchOfficialVm.fromJS(item));
            }
            if (Array.isArray(_data["coaches"])) {
                this.coaches = [] as any;
                for (let item of _data["coaches"])
                    this.coaches!.push(MatchCoachVm.fromJS(item));
            }
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(MatchPlayerVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MatchDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competition"] = this.competition ? this.competition.toJSON() : <any>undefined;
        data["homeTeam"] = this.homeTeam ? this.homeTeam.toJSON() : <any>undefined;
        data["awayTeam"] = this.awayTeam ? this.awayTeam.toJSON() : <any>undefined;
        data["competitionLogo"] = this.competitionLogo;
        data["federationLogo"] = this.federationLogo;
        if (Array.isArray(this.officials)) {
            data["officials"] = [];
            for (let item of this.officials)
                data["officials"].push(item.toJSON());
        }
        if (Array.isArray(this.coaches)) {
            data["coaches"] = [];
            for (let item of this.coaches)
                data["coaches"].push(item.toJSON());
        }
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMatchDetailVm extends IMatchVm {
    competition: CompetitionVm | undefined;
    homeTeam: TeamVm | undefined;
    awayTeam: TeamVm | undefined;
    competitionLogo: string | undefined;
    federationLogo: string | undefined;
    officials: MatchOfficialVm[] | undefined;
    coaches: MatchCoachVm[] | undefined;
    players: MatchPlayerVm[] | undefined;
}

export class MatchOfficialVm implements IMatchOfficialVm {
    id!: number | undefined;
    matchId!: number;
    officialId!: number;
    roleId!: OfficialRoleEnum;
    match!: MatchVm;
    official!: OfficialVm;
    role!: string;
    confirmed!: boolean;

    constructor(data?: IMatchOfficialVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.officialId = _data["officialId"];
            this.roleId = _data["roleId"];
            this.match = _data["match"] ? MatchVm.fromJS(_data["match"]) : <any>undefined;
            this.official = _data["official"] ? OfficialVm.fromJS(_data["official"]) : <any>undefined;
            this.role = _data["role"];
            this.confirmed = _data["confirmed"];
        }
    }

    static fromJS(data: any): MatchOfficialVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchOfficialVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["officialId"] = this.officialId;
        data["roleId"] = this.roleId;
        data["match"] = this.match ? this.match.toJSON() : <any>undefined;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["role"] = this.role;
        data["confirmed"] = this.confirmed;
        return data;
    }
}

export interface IMatchOfficialVm {
    id: number | undefined;
    matchId: number;
    officialId: number;
    roleId: OfficialRoleEnum;
    match: MatchVm;
    official: OfficialVm;
    role: string;
    confirmed: boolean;
}

export class MatchPlayerVm implements IMatchPlayerVm {
    id!: number | undefined;
    number!: number;
    capNumber!: number;
    matchId!: number;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum;
    position!: string;
    match!: MatchVm;
    player!: PlayerVm;
    team!: TeamVm;

    constructor(data?: IMatchPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.capNumber = _data["capNumber"];
            this.matchId = _data["matchId"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
            this.position = _data["position"];
            this.match = _data["match"] ? MatchVm.fromJS(_data["match"]) : <any>undefined;
            this.player = _data["player"] ? PlayerVm.fromJS(_data["player"]) : <any>undefined;
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MatchPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["capNumber"] = this.capNumber;
        data["matchId"] = this.matchId;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        data["position"] = this.position;
        data["match"] = this.match ? this.match.toJSON() : <any>undefined;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMatchPlayerVm {
    id: number | undefined;
    number: number;
    capNumber: number;
    matchId: number;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum;
    position: string;
    match: MatchVm;
    player: PlayerVm;
    team: TeamVm;
}

export class LatestFinishedMatchLineupVm implements ILatestFinishedMatchLineupVm {
    homePlayers!: MatchPlayerLineupCopyItemVm[] | undefined;
    awayPlayers!: MatchPlayerLineupCopyItemVm[] | undefined;

    constructor(data?: ILatestFinishedMatchLineupVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["homePlayers"])) {
                this.homePlayers = [] as any;
                for (let item of _data["homePlayers"])
                    this.homePlayers!.push(MatchPlayerLineupCopyItemVm.fromJS(item));
            }
            if (Array.isArray(_data["awayPlayers"])) {
                this.awayPlayers = [] as any;
                for (let item of _data["awayPlayers"])
                    this.awayPlayers!.push(MatchPlayerLineupCopyItemVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LatestFinishedMatchLineupVm {
        data = typeof data === 'object' ? data : {};
        let result = new LatestFinishedMatchLineupVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.homePlayers)) {
            data["homePlayers"] = [];
            for (let item of this.homePlayers)
                data["homePlayers"].push(item.toJSON());
        }
        if (Array.isArray(this.awayPlayers)) {
            data["awayPlayers"] = [];
            for (let item of this.awayPlayers)
                data["awayPlayers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILatestFinishedMatchLineupVm {
    homePlayers: MatchPlayerLineupCopyItemVm[] | undefined;
    awayPlayers: MatchPlayerLineupCopyItemVm[] | undefined;
}

export class MatchPlayerLineupCopyItemVm implements IMatchPlayerLineupCopyItemVm {
    number!: number;
    capNumber!: number;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum;

    constructor(data?: IMatchPlayerLineupCopyItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.capNumber = _data["capNumber"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
        }
    }

    static fromJS(data: any): MatchPlayerLineupCopyItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchPlayerLineupCopyItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["capNumber"] = this.capNumber;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        return data;
    }
}

export interface IMatchPlayerLineupCopyItemVm {
    number: number;
    capNumber: number;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum;
}

export class CreateMatchCommandOfMatch implements ICreateMatchCommandOfMatch {
    competitionId!: number;
    homeTeamId!: number;
    awayTeamId!: number;
    countryId!: number | undefined;
    cityId!: number | undefined;
    matchSegmentId!: MatchSegmentEnum;
    statusId!: MatchStatusEnum;
    venue!: string | undefined;
    round!: string | undefined;
    number!: string | undefined;
    competitionStage!: string;
    matchSegmentLength!: number;
    startDate!: Date;
    endDate!: Date | undefined;
    homeTeamGoalsQ1!: number | undefined;
    awayTeamGoalsQ1!: number | undefined;
    homeTeamGoalsQ2!: number | undefined;
    awayTeamGoalsQ2!: number | undefined;
    homeTeamGoalsQ3!: number | undefined;
    awayTeamGoalsQ3!: number | undefined;
    homeTeamGoalsQ4!: number | undefined;
    awayTeamGoalsQ4!: number | undefined;
    homeTeamGoalsOT!: number | undefined;
    awayTeamGoalsOT!: number | undefined;
    disciplinaryNote!: string | undefined;

    constructor(data?: ICreateMatchCommandOfMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionId = _data["competitionId"];
            this.homeTeamId = _data["homeTeamId"];
            this.awayTeamId = _data["awayTeamId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.statusId = _data["statusId"];
            this.venue = _data["venue"];
            this.round = _data["round"];
            this.number = _data["number"];
            this.competitionStage = _data["competitionStage"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.homeTeamGoalsQ1 = _data["homeTeamGoalsQ1"];
            this.awayTeamGoalsQ1 = _data["awayTeamGoalsQ1"];
            this.homeTeamGoalsQ2 = _data["homeTeamGoalsQ2"];
            this.awayTeamGoalsQ2 = _data["awayTeamGoalsQ2"];
            this.homeTeamGoalsQ3 = _data["homeTeamGoalsQ3"];
            this.awayTeamGoalsQ3 = _data["awayTeamGoalsQ3"];
            this.homeTeamGoalsQ4 = _data["homeTeamGoalsQ4"];
            this.awayTeamGoalsQ4 = _data["awayTeamGoalsQ4"];
            this.homeTeamGoalsOT = _data["homeTeamGoalsOT"];
            this.awayTeamGoalsOT = _data["awayTeamGoalsOT"];
            this.disciplinaryNote = _data["disciplinaryNote"];
        }
    }

    static fromJS(data: any): CreateMatchCommandOfMatch {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchCommandOfMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionId"] = this.competitionId;
        data["homeTeamId"] = this.homeTeamId;
        data["awayTeamId"] = this.awayTeamId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["matchSegmentId"] = this.matchSegmentId;
        data["statusId"] = this.statusId;
        data["venue"] = this.venue;
        data["round"] = this.round;
        data["number"] = this.number;
        data["competitionStage"] = this.competitionStage;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["homeTeamGoalsQ1"] = this.homeTeamGoalsQ1;
        data["awayTeamGoalsQ1"] = this.awayTeamGoalsQ1;
        data["homeTeamGoalsQ2"] = this.homeTeamGoalsQ2;
        data["awayTeamGoalsQ2"] = this.awayTeamGoalsQ2;
        data["homeTeamGoalsQ3"] = this.homeTeamGoalsQ3;
        data["awayTeamGoalsQ3"] = this.awayTeamGoalsQ3;
        data["homeTeamGoalsQ4"] = this.homeTeamGoalsQ4;
        data["awayTeamGoalsQ4"] = this.awayTeamGoalsQ4;
        data["homeTeamGoalsOT"] = this.homeTeamGoalsOT;
        data["awayTeamGoalsOT"] = this.awayTeamGoalsOT;
        data["disciplinaryNote"] = this.disciplinaryNote;
        return data;
    }
}

export interface ICreateMatchCommandOfMatch {
    competitionId: number;
    homeTeamId: number;
    awayTeamId: number;
    countryId: number | undefined;
    cityId: number | undefined;
    matchSegmentId: MatchSegmentEnum;
    statusId: MatchStatusEnum;
    venue: string | undefined;
    round: string | undefined;
    number: string | undefined;
    competitionStage: string;
    matchSegmentLength: number;
    startDate: Date;
    endDate: Date | undefined;
    homeTeamGoalsQ1: number | undefined;
    awayTeamGoalsQ1: number | undefined;
    homeTeamGoalsQ2: number | undefined;
    awayTeamGoalsQ2: number | undefined;
    homeTeamGoalsQ3: number | undefined;
    awayTeamGoalsQ3: number | undefined;
    homeTeamGoalsQ4: number | undefined;
    awayTeamGoalsQ4: number | undefined;
    homeTeamGoalsOT: number | undefined;
    awayTeamGoalsOT: number | undefined;
    disciplinaryNote: string | undefined;
}

export class UpdateMatchCommand implements IUpdateMatchCommand {
    id!: number;
    competitionId!: number;
    homeTeamId!: number;
    awayTeamId!: number;
    countryId!: number | undefined;
    cityId!: number | undefined;
    matchSegmentId!: MatchSegmentEnum;
    statusId!: MatchStatusEnum;
    venue!: string | undefined;
    round!: string | undefined;
    number!: string | undefined;
    competitionStage!: string;
    matchSegmentLength!: number;
    startDate!: Date;
    endDate!: Date | undefined;
    homeTeamGoalsQ1!: number | undefined;
    awayTeamGoalsQ1!: number | undefined;
    homeTeamGoalsQ2!: number | undefined;
    awayTeamGoalsQ2!: number | undefined;
    homeTeamGoalsQ3!: number | undefined;
    awayTeamGoalsQ3!: number | undefined;
    homeTeamGoalsQ4!: number | undefined;
    awayTeamGoalsQ4!: number | undefined;
    homeTeamGoalsOT!: number | undefined;
    awayTeamGoalsOT!: number | undefined;
    disciplinaryNote!: string | undefined;

    constructor(data?: IUpdateMatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.competitionId = _data["competitionId"];
            this.homeTeamId = _data["homeTeamId"];
            this.awayTeamId = _data["awayTeamId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.statusId = _data["statusId"];
            this.venue = _data["venue"];
            this.round = _data["round"];
            this.number = _data["number"];
            this.competitionStage = _data["competitionStage"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.homeTeamGoalsQ1 = _data["homeTeamGoalsQ1"];
            this.awayTeamGoalsQ1 = _data["awayTeamGoalsQ1"];
            this.homeTeamGoalsQ2 = _data["homeTeamGoalsQ2"];
            this.awayTeamGoalsQ2 = _data["awayTeamGoalsQ2"];
            this.homeTeamGoalsQ3 = _data["homeTeamGoalsQ3"];
            this.awayTeamGoalsQ3 = _data["awayTeamGoalsQ3"];
            this.homeTeamGoalsQ4 = _data["homeTeamGoalsQ4"];
            this.awayTeamGoalsQ4 = _data["awayTeamGoalsQ4"];
            this.homeTeamGoalsOT = _data["homeTeamGoalsOT"];
            this.awayTeamGoalsOT = _data["awayTeamGoalsOT"];
            this.disciplinaryNote = _data["disciplinaryNote"];
        }
    }

    static fromJS(data: any): UpdateMatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["competitionId"] = this.competitionId;
        data["homeTeamId"] = this.homeTeamId;
        data["awayTeamId"] = this.awayTeamId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["matchSegmentId"] = this.matchSegmentId;
        data["statusId"] = this.statusId;
        data["venue"] = this.venue;
        data["round"] = this.round;
        data["number"] = this.number;
        data["competitionStage"] = this.competitionStage;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["homeTeamGoalsQ1"] = this.homeTeamGoalsQ1;
        data["awayTeamGoalsQ1"] = this.awayTeamGoalsQ1;
        data["homeTeamGoalsQ2"] = this.homeTeamGoalsQ2;
        data["awayTeamGoalsQ2"] = this.awayTeamGoalsQ2;
        data["homeTeamGoalsQ3"] = this.homeTeamGoalsQ3;
        data["awayTeamGoalsQ3"] = this.awayTeamGoalsQ3;
        data["homeTeamGoalsQ4"] = this.homeTeamGoalsQ4;
        data["awayTeamGoalsQ4"] = this.awayTeamGoalsQ4;
        data["homeTeamGoalsOT"] = this.homeTeamGoalsOT;
        data["awayTeamGoalsOT"] = this.awayTeamGoalsOT;
        data["disciplinaryNote"] = this.disciplinaryNote;
        return data;
    }
}

export interface IUpdateMatchCommand {
    id: number;
    competitionId: number;
    homeTeamId: number;
    awayTeamId: number;
    countryId: number | undefined;
    cityId: number | undefined;
    matchSegmentId: MatchSegmentEnum;
    statusId: MatchStatusEnum;
    venue: string | undefined;
    round: string | undefined;
    number: string | undefined;
    competitionStage: string;
    matchSegmentLength: number;
    startDate: Date;
    endDate: Date | undefined;
    homeTeamGoalsQ1: number | undefined;
    awayTeamGoalsQ1: number | undefined;
    homeTeamGoalsQ2: number | undefined;
    awayTeamGoalsQ2: number | undefined;
    homeTeamGoalsQ3: number | undefined;
    awayTeamGoalsQ3: number | undefined;
    homeTeamGoalsQ4: number | undefined;
    awayTeamGoalsQ4: number | undefined;
    homeTeamGoalsOT: number | undefined;
    awayTeamGoalsOT: number | undefined;
    disciplinaryNote: string | undefined;
}

export class CreateOrUpdateMatchOfficialsCommand implements ICreateOrUpdateMatchOfficialsCommand {
    matchId!: number;
    matchOfficials!: CreateMatchOfficialCommandOfMatchOfficial[] | undefined;

    constructor(data?: ICreateOrUpdateMatchOfficialsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            if (Array.isArray(_data["matchOfficials"])) {
                this.matchOfficials = [] as any;
                for (let item of _data["matchOfficials"])
                    this.matchOfficials!.push(CreateMatchOfficialCommandOfMatchOfficial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateMatchOfficialsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMatchOfficialsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        if (Array.isArray(this.matchOfficials)) {
            data["matchOfficials"] = [];
            for (let item of this.matchOfficials)
                data["matchOfficials"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateMatchOfficialsCommand {
    matchId: number;
    matchOfficials: CreateMatchOfficialCommandOfMatchOfficial[] | undefined;
}

export class CreateMatchOfficialCommandOfMatchOfficial implements ICreateMatchOfficialCommandOfMatchOfficial {
    id!: number;
    matchId!: number;
    officialId!: number;
    roleId!: OfficialRoleEnum;

    constructor(data?: ICreateMatchOfficialCommandOfMatchOfficial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.officialId = _data["officialId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): CreateMatchOfficialCommandOfMatchOfficial {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchOfficialCommandOfMatchOfficial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["officialId"] = this.officialId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ICreateMatchOfficialCommandOfMatchOfficial {
    id: number;
    matchId: number;
    officialId: number;
    roleId: OfficialRoleEnum;
}

export class CreateOrUpdateMatchPlayersCommand implements ICreateOrUpdateMatchPlayersCommand {
    matchId!: number;
    matchPlayers!: CreateMatchPlayerCommandOfMatchPlayer[] | undefined;

    constructor(data?: ICreateOrUpdateMatchPlayersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            if (Array.isArray(_data["matchPlayers"])) {
                this.matchPlayers = [] as any;
                for (let item of _data["matchPlayers"])
                    this.matchPlayers!.push(CreateMatchPlayerCommandOfMatchPlayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateMatchPlayersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMatchPlayersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        if (Array.isArray(this.matchPlayers)) {
            data["matchPlayers"] = [];
            for (let item of this.matchPlayers)
                data["matchPlayers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateMatchPlayersCommand {
    matchId: number;
    matchPlayers: CreateMatchPlayerCommandOfMatchPlayer[] | undefined;
}

export class CreateMatchPlayerCommandOfMatchPlayer implements ICreateMatchPlayerCommandOfMatchPlayer {
    id!: number;
    number!: number;
    capNumber!: number;
    matchId!: number;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum;

    constructor(data?: ICreateMatchPlayerCommandOfMatchPlayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.capNumber = _data["capNumber"];
            this.matchId = _data["matchId"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
        }
    }

    static fromJS(data: any): CreateMatchPlayerCommandOfMatchPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchPlayerCommandOfMatchPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["capNumber"] = this.capNumber;
        data["matchId"] = this.matchId;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        return data;
    }
}

export interface ICreateMatchPlayerCommandOfMatchPlayer {
    id: number;
    number: number;
    capNumber: number;
    matchId: number;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum;
}

export class CreateOrUpdateMatchCoachesCommand implements ICreateOrUpdateMatchCoachesCommand {
    matchId!: number;
    matchCoaches!: CreateMatchCoachCommandOfMatchCoach[] | undefined;

    constructor(data?: ICreateOrUpdateMatchCoachesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            if (Array.isArray(_data["matchCoaches"])) {
                this.matchCoaches = [] as any;
                for (let item of _data["matchCoaches"])
                    this.matchCoaches!.push(CreateMatchCoachCommandOfMatchCoach.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateMatchCoachesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMatchCoachesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        if (Array.isArray(this.matchCoaches)) {
            data["matchCoaches"] = [];
            for (let item of this.matchCoaches)
                data["matchCoaches"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateMatchCoachesCommand {
    matchId: number;
    matchCoaches: CreateMatchCoachCommandOfMatchCoach[] | undefined;
}

export class UpdateMatchLogCommand implements IUpdateMatchLogCommand {
    matchId!: number;
    matchCoaches!: CreateMatchCoachCommandOfMatchCoach[] | undefined;
    matchOfficials!: CreateMatchOfficialCommandOfMatchOfficial[] | undefined;
    matchPlayers!: CreateMatchPlayerCommandOfMatchPlayer[] | undefined;

    constructor(data?: IUpdateMatchLogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            if (Array.isArray(_data["matchCoaches"])) {
                this.matchCoaches = [] as any;
                for (let item of _data["matchCoaches"])
                    this.matchCoaches!.push(CreateMatchCoachCommandOfMatchCoach.fromJS(item));
            }
            if (Array.isArray(_data["matchOfficials"])) {
                this.matchOfficials = [] as any;
                for (let item of _data["matchOfficials"])
                    this.matchOfficials!.push(CreateMatchOfficialCommandOfMatchOfficial.fromJS(item));
            }
            if (Array.isArray(_data["matchPlayers"])) {
                this.matchPlayers = [] as any;
                for (let item of _data["matchPlayers"])
                    this.matchPlayers!.push(CreateMatchPlayerCommandOfMatchPlayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMatchLogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchLogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        if (Array.isArray(this.matchCoaches)) {
            data["matchCoaches"] = [];
            for (let item of this.matchCoaches)
                data["matchCoaches"].push(item.toJSON());
        }
        if (Array.isArray(this.matchOfficials)) {
            data["matchOfficials"] = [];
            for (let item of this.matchOfficials)
                data["matchOfficials"].push(item.toJSON());
        }
        if (Array.isArray(this.matchPlayers)) {
            data["matchPlayers"] = [];
            for (let item of this.matchPlayers)
                data["matchPlayers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateMatchLogCommand {
    matchId: number;
    matchCoaches: CreateMatchCoachCommandOfMatchCoach[] | undefined;
    matchOfficials: CreateMatchOfficialCommandOfMatchOfficial[] | undefined;
    matchPlayers: CreateMatchPlayerCommandOfMatchPlayer[] | undefined;
}

export class UpdateMatchDisciplinaryNoteCommand implements IUpdateMatchDisciplinaryNoteCommand {
    matchId!: number;
    disciplinaryNote!: string | undefined;

    constructor(data?: IUpdateMatchDisciplinaryNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.disciplinaryNote = _data["disciplinaryNote"];
        }
    }

    static fromJS(data: any): UpdateMatchDisciplinaryNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchDisciplinaryNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["disciplinaryNote"] = this.disciplinaryNote;
        return data;
    }
}

export interface IUpdateMatchDisciplinaryNoteCommand {
    matchId: number;
    disciplinaryNote: string | undefined;
}

export class ConfirmMatchLogCommand implements IConfirmMatchLogCommand {
    matchOfficialId!: number;
    pin!: string;

    constructor(data?: IConfirmMatchLogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchOfficialId = _data["matchOfficialId"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): ConfirmMatchLogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmMatchLogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchOfficialId"] = this.matchOfficialId;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IConfirmMatchLogCommand {
    matchOfficialId: number;
    pin: string;
}

export class UpdateMatchOfficialCommandOfMatchOfficial extends CreateMatchOfficialCommandOfMatchOfficial implements IUpdateMatchOfficialCommandOfMatchOfficial {

    constructor(data?: IUpdateMatchOfficialCommandOfMatchOfficial) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateMatchOfficialCommandOfMatchOfficial {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchOfficialCommandOfMatchOfficial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMatchOfficialCommandOfMatchOfficial extends ICreateMatchOfficialCommandOfMatchOfficial {
}

export class UpdateMatchPlayerCommandOfMatchPlayer extends CreateMatchPlayerCommandOfMatchPlayer implements IUpdateMatchPlayerCommandOfMatchPlayer {

    constructor(data?: IUpdateMatchPlayerCommandOfMatchPlayer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateMatchPlayerCommandOfMatchPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchPlayerCommandOfMatchPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMatchPlayerCommandOfMatchPlayer extends ICreateMatchPlayerCommandOfMatchPlayer {
}

export class PaginatedListOfOfficialVm implements IPaginatedListOfOfficialVm {
    pageItems!: OfficialVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfOfficialVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(OfficialVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfOfficialVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfOfficialVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfOfficialVm {
    pageItems: OfficialVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class OfficialDetailVm implements IOfficialDetailVm {
    id!: number;
    title!: string | undefined;
    personId!: number;
    person!: PersonVm;
    federations!: FederationOfficialVm[];
    matches!: MatchOfficialVm[];

    constructor(data?: IOfficialDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? PersonVm.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["federations"])) {
                this.federations = [] as any;
                for (let item of _data["federations"])
                    this.federations!.push(FederationOfficialVm.fromJS(item));
            }
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchOfficialVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfficialDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.federations)) {
            data["federations"] = [];
            for (let item of this.federations)
                data["federations"].push(item.toJSON());
        }
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfficialDetailVm {
    id: number;
    title: string | undefined;
    personId: number;
    person: PersonVm;
    federations: FederationOfficialVm[];
    matches: MatchOfficialVm[];
}

export class CreateOfficialCommand implements ICreateOfficialCommand {
    title!: string | undefined;
    personId!: number;
    federations!: CreateFederationOfficialCommandOfFederationOfficial[];

    constructor(data?: ICreateOfficialCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.federations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.personId = _data["personId"];
            if (Array.isArray(_data["federations"])) {
                this.federations = [] as any;
                for (let item of _data["federations"])
                    this.federations!.push(CreateFederationOfficialCommandOfFederationOfficial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOfficialCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOfficialCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["personId"] = this.personId;
        if (Array.isArray(this.federations)) {
            data["federations"] = [];
            for (let item of this.federations)
                data["federations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOfficialCommand {
    title: string | undefined;
    personId: number;
    federations: CreateFederationOfficialCommandOfFederationOfficial[];
}

export class UpdateOfficialCommandOfOfficial implements IUpdateOfficialCommandOfOfficial {
    id!: number;
    title!: string | undefined;

    constructor(data?: IUpdateOfficialCommandOfOfficial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateOfficialCommandOfOfficial {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOfficialCommandOfOfficial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateOfficialCommandOfOfficial {
    id: number;
    title: string | undefined;
}

export class UpdateOfficialPinCommand implements IUpdateOfficialPinCommand {
    id!: number;
    pin!: string;

    constructor(data?: IUpdateOfficialPinCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): UpdateOfficialPinCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOfficialPinCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IUpdateOfficialPinCommand {
    id: number;
    pin: string;
}

export class CreatePersonCommandOfPerson implements ICreatePersonCommandOfPerson {
    name!: string;
    surname!: string;
    birthDate!: Date;
    nationality!: string | undefined;
    address!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    photo!: string | undefined;
    countryOfBirthId!: number | undefined;
    cityOfBirthId!: number | undefined;
    playerId!: number | undefined;
    coachId!: number | undefined;
    officialId!: number | undefined;
    official!: CreateOfficialCommand | undefined;
    player!: CreatePlayerCommand | undefined;
    coach!: CreateCoachCommand | undefined;

    constructor(data?: ICreatePersonCommandOfPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.nationality = _data["nationality"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.photo = _data["photo"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.cityOfBirthId = _data["cityOfBirthId"];
            this.playerId = _data["playerId"];
            this.coachId = _data["coachId"];
            this.officialId = _data["officialId"];
            this.official = _data["official"] ? CreateOfficialCommand.fromJS(_data["official"]) : <any>undefined;
            this.player = _data["player"] ? CreatePlayerCommand.fromJS(_data["player"]) : <any>undefined;
            this.coach = _data["coach"] ? CreateCoachCommand.fromJS(_data["coach"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePersonCommandOfPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonCommandOfPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["nationality"] = this.nationality;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["photo"] = this.photo;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["cityOfBirthId"] = this.cityOfBirthId;
        data["playerId"] = this.playerId;
        data["coachId"] = this.coachId;
        data["officialId"] = this.officialId;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePersonCommandOfPerson {
    name: string;
    surname: string;
    birthDate: Date;
    nationality: string | undefined;
    address: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    photo: string | undefined;
    countryOfBirthId: number | undefined;
    cityOfBirthId: number | undefined;
    playerId: number | undefined;
    coachId: number | undefined;
    officialId: number | undefined;
    official: CreateOfficialCommand | undefined;
    player: CreatePlayerCommand | undefined;
    coach: CreateCoachCommand | undefined;
}

export class CreatePlayerCommand implements ICreatePlayerCommand {
    personId!: number;
    primaryPositionId!: PlayerPositionEnum | undefined;
    height!: string | undefined;
    weight!: string | undefined;
    dominantHand!: string | undefined;
    clubs!: CreateClubPlayerCommandOfClubPlayer[] | undefined;
    teams!: CreateTeamPlayerCommandOfTeamPlayer[] | undefined;

    constructor(data?: ICreatePlayerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.primaryPositionId = _data["primaryPositionId"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.dominantHand = _data["dominantHand"];
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(CreateClubPlayerCommandOfClubPlayer.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(CreateTeamPlayerCommandOfTeamPlayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePlayerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlayerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["primaryPositionId"] = this.primaryPositionId;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["dominantHand"] = this.dominantHand;
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePlayerCommand {
    personId: number;
    primaryPositionId: PlayerPositionEnum | undefined;
    height: string | undefined;
    weight: string | undefined;
    dominantHand: string | undefined;
    clubs: CreateClubPlayerCommandOfClubPlayer[] | undefined;
    teams: CreateTeamPlayerCommandOfTeamPlayer[] | undefined;
}

export class CreateTeamPlayerCommandOfTeamPlayer implements ICreateTeamPlayerCommandOfTeamPlayer {
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    capNumber!: number | undefined;

    constructor(data?: ICreateTeamPlayerCommandOfTeamPlayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.capNumber = _data["capNumber"];
        }
    }

    static fromJS(data: any): CreateTeamPlayerCommandOfTeamPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamPlayerCommandOfTeamPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["capNumber"] = this.capNumber;
        return data;
    }
}

export interface ICreateTeamPlayerCommandOfTeamPlayer {
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    capNumber: number | undefined;
}

export class UpdatePersonCommandOfPerson extends CreatePersonCommandOfPerson implements IUpdatePersonCommandOfPerson {
    id!: number;

    constructor(data?: IUpdatePersonCommandOfPerson) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePersonCommandOfPerson {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonCommandOfPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePersonCommandOfPerson extends ICreatePersonCommandOfPerson {
    id: number;
}

export class PaginatedListOfPlayerVm implements IPaginatedListOfPlayerVm {
    pageItems!: PlayerVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(PlayerVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfPlayerVm {
    pageItems: PlayerVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class PlayerLightProfileVm implements IPlayerLightProfileVm {
    id!: number;
    height!: string | undefined;
    weight!: string | undefined;
    dominantHand!: string | undefined;
    primaryPositionId!: PlayerPositionEnum | undefined;
    primaryPosition!: string | undefined;
    personId!: number;
    person!: PersonVm;
    matches!: PlayerMatchLightRowVm[];

    constructor(data?: IPlayerLightProfileVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.dominantHand = _data["dominantHand"];
            this.primaryPositionId = _data["primaryPositionId"];
            this.primaryPosition = _data["primaryPosition"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? PersonVm.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(PlayerMatchLightRowVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerLightProfileVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerLightProfileVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["dominantHand"] = this.dominantHand;
        data["primaryPositionId"] = this.primaryPositionId;
        data["primaryPosition"] = this.primaryPosition;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayerLightProfileVm {
    id: number;
    height: string | undefined;
    weight: string | undefined;
    dominantHand: string | undefined;
    primaryPositionId: PlayerPositionEnum | undefined;
    primaryPosition: string | undefined;
    personId: number;
    person: PersonVm;
    matches: PlayerMatchLightRowVm[];
}

export class PlayerMatchLightRowVm implements IPlayerMatchLightRowVm {
    matchId!: number;
    match!: MatchLightVm;

    constructor(data?: IPlayerMatchLightRowVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.match = _data["match"] ? MatchLightVm.fromJS(_data["match"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayerMatchLightRowVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerMatchLightRowVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["match"] = this.match ? this.match.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlayerMatchLightRowVm {
    matchId: number;
    match: MatchLightVm;
}

export class MatchLightVm implements IMatchLightVm {
    id!: number;
    homeTeamId!: number;
    homeTeamDisplayName!: string;
    awayTeamId!: number;
    awayTeamDisplayName!: string | undefined;
    federationId!: number;
    federationDisplayName!: string;
    competitionId!: number;
    competitionDisplayName!: string;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;
    venue!: string | undefined;
    round!: string | undefined;
    number!: string | undefined;
    competitionStage!: string | undefined;
    matchSegmentLength!: number;
    startDate!: Date;
    endDate!: Date | undefined;
    statusId!: MatchStatusEnum;
    status!: string;
    matchSegmentId!: MatchSegmentEnum;
    matchSegment!: string;
    homeTeamGoalsTotal!: number | undefined;
    awayTeamGoalsTotal!: number | undefined;
    homeTeamGoalsQ1!: number | undefined;
    awayTeamGoalsQ1!: number | undefined;
    homeTeamGoalsQ2!: number | undefined;
    awayTeamGoalsQ2!: number | undefined;
    homeTeamGoalsQ3!: number | undefined;
    awayTeamGoalsQ3!: number | undefined;
    homeTeamGoalsQ4!: number | undefined;
    awayTeamGoalsQ4!: number | undefined;
    homeTeamGoalsOT!: number | undefined;
    awayTeamGoalsOT!: number | undefined;

    constructor(data?: IMatchLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.homeTeamId = _data["homeTeamId"];
            this.homeTeamDisplayName = _data["homeTeamDisplayName"];
            this.awayTeamId = _data["awayTeamId"];
            this.awayTeamDisplayName = _data["awayTeamDisplayName"];
            this.federationId = _data["federationId"];
            this.federationDisplayName = _data["federationDisplayName"];
            this.competitionId = _data["competitionId"];
            this.competitionDisplayName = _data["competitionDisplayName"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.venue = _data["venue"];
            this.round = _data["round"];
            this.number = _data["number"];
            this.competitionStage = _data["competitionStage"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.matchSegment = _data["matchSegment"];
            this.homeTeamGoalsTotal = _data["homeTeamGoalsTotal"];
            this.awayTeamGoalsTotal = _data["awayTeamGoalsTotal"];
            this.homeTeamGoalsQ1 = _data["homeTeamGoalsQ1"];
            this.awayTeamGoalsQ1 = _data["awayTeamGoalsQ1"];
            this.homeTeamGoalsQ2 = _data["homeTeamGoalsQ2"];
            this.awayTeamGoalsQ2 = _data["awayTeamGoalsQ2"];
            this.homeTeamGoalsQ3 = _data["homeTeamGoalsQ3"];
            this.awayTeamGoalsQ3 = _data["awayTeamGoalsQ3"];
            this.homeTeamGoalsQ4 = _data["homeTeamGoalsQ4"];
            this.awayTeamGoalsQ4 = _data["awayTeamGoalsQ4"];
            this.homeTeamGoalsOT = _data["homeTeamGoalsOT"];
            this.awayTeamGoalsOT = _data["awayTeamGoalsOT"];
        }
    }

    static fromJS(data: any): MatchLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeTeamId"] = this.homeTeamId;
        data["homeTeamDisplayName"] = this.homeTeamDisplayName;
        data["awayTeamId"] = this.awayTeamId;
        data["awayTeamDisplayName"] = this.awayTeamDisplayName;
        data["federationId"] = this.federationId;
        data["federationDisplayName"] = this.federationDisplayName;
        data["competitionId"] = this.competitionId;
        data["competitionDisplayName"] = this.competitionDisplayName;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["venue"] = this.venue;
        data["round"] = this.round;
        data["number"] = this.number;
        data["competitionStage"] = this.competitionStage;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["matchSegmentId"] = this.matchSegmentId;
        data["matchSegment"] = this.matchSegment;
        data["homeTeamGoalsTotal"] = this.homeTeamGoalsTotal;
        data["awayTeamGoalsTotal"] = this.awayTeamGoalsTotal;
        data["homeTeamGoalsQ1"] = this.homeTeamGoalsQ1;
        data["awayTeamGoalsQ1"] = this.awayTeamGoalsQ1;
        data["homeTeamGoalsQ2"] = this.homeTeamGoalsQ2;
        data["awayTeamGoalsQ2"] = this.awayTeamGoalsQ2;
        data["homeTeamGoalsQ3"] = this.homeTeamGoalsQ3;
        data["awayTeamGoalsQ3"] = this.awayTeamGoalsQ3;
        data["homeTeamGoalsQ4"] = this.homeTeamGoalsQ4;
        data["awayTeamGoalsQ4"] = this.awayTeamGoalsQ4;
        data["homeTeamGoalsOT"] = this.homeTeamGoalsOT;
        data["awayTeamGoalsOT"] = this.awayTeamGoalsOT;
        return data;
    }
}

export interface IMatchLightVm {
    id: number;
    homeTeamId: number;
    homeTeamDisplayName: string;
    awayTeamId: number;
    awayTeamDisplayName: string | undefined;
    federationId: number;
    federationDisplayName: string;
    competitionId: number;
    competitionDisplayName: string;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
    venue: string | undefined;
    round: string | undefined;
    number: string | undefined;
    competitionStage: string | undefined;
    matchSegmentLength: number;
    startDate: Date;
    endDate: Date | undefined;
    statusId: MatchStatusEnum;
    status: string;
    matchSegmentId: MatchSegmentEnum;
    matchSegment: string;
    homeTeamGoalsTotal: number | undefined;
    awayTeamGoalsTotal: number | undefined;
    homeTeamGoalsQ1: number | undefined;
    awayTeamGoalsQ1: number | undefined;
    homeTeamGoalsQ2: number | undefined;
    awayTeamGoalsQ2: number | undefined;
    homeTeamGoalsQ3: number | undefined;
    awayTeamGoalsQ3: number | undefined;
    homeTeamGoalsQ4: number | undefined;
    awayTeamGoalsQ4: number | undefined;
    homeTeamGoalsOT: number | undefined;
    awayTeamGoalsOT: number | undefined;
}

export class PlayerDetailVm implements IPlayerDetailVm {
    id!: number;
    height!: string | undefined;
    weight!: string | undefined;
    dominantHand!: string | undefined;
    primaryPositionId!: PlayerPositionEnum | undefined;
    primaryPosition!: string | undefined;
    personId!: number;
    person!: PersonVm;
    clubs!: ClubPlayerVm[];
    teams!: TeamPlayerVm[];
    matches!: MatchPlayerVm[];

    constructor(data?: IPlayerDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.dominantHand = _data["dominantHand"];
            this.primaryPositionId = _data["primaryPositionId"];
            this.primaryPosition = _data["primaryPosition"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? PersonVm.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(ClubPlayerVm.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamPlayerVm.fromJS(item));
            }
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchPlayerVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["dominantHand"] = this.dominantHand;
        data["primaryPositionId"] = this.primaryPositionId;
        data["primaryPosition"] = this.primaryPosition;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayerDetailVm {
    id: number;
    height: string | undefined;
    weight: string | undefined;
    dominantHand: string | undefined;
    primaryPositionId: PlayerPositionEnum | undefined;
    primaryPosition: string | undefined;
    personId: number;
    person: PersonVm;
    clubs: ClubPlayerVm[];
    teams: TeamPlayerVm[];
    matches: MatchPlayerVm[];
}

export class TeamPlayerVm implements ITeamPlayerVm {
    id!: number | undefined;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    capNumber!: number | undefined;
    player!: PlayerVm;
    team!: TeamVm;
    position!: string | undefined;

    constructor(data?: ITeamPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.capNumber = _data["capNumber"];
            this.player = _data["player"] ? PlayerVm.fromJS(_data["player"]) : <any>undefined;
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): TeamPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["capNumber"] = this.capNumber;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["position"] = this.position;
        return data;
    }
}

export interface ITeamPlayerVm {
    id: number | undefined;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    capNumber: number | undefined;
    player: PlayerVm;
    team: TeamVm;
    position: string | undefined;
}

export class PlayerExtendedVm extends PlayerVm implements IPlayerExtendedVm {
    photo!: string | undefined;

    constructor(data?: IPlayerExtendedVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.photo = _data["photo"];
        }
    }

    static fromJS(data: any): PlayerExtendedVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerExtendedVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photo"] = this.photo;
        super.toJSON(data);
        return data;
    }
}

export interface IPlayerExtendedVm extends IPlayerVm {
    photo: string | undefined;
}

export class UpdatePlayerCommandOfPlayer implements IUpdatePlayerCommandOfPlayer {
    id!: number;
    primaryPositionId!: PlayerPositionEnum | undefined;
    height!: string | undefined;
    weight!: string | undefined;
    dominantHand!: string | undefined;

    constructor(data?: IUpdatePlayerCommandOfPlayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.primaryPositionId = _data["primaryPositionId"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.dominantHand = _data["dominantHand"];
        }
    }

    static fromJS(data: any): UpdatePlayerCommandOfPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlayerCommandOfPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryPositionId"] = this.primaryPositionId;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["dominantHand"] = this.dominantHand;
        return data;
    }
}

export interface IUpdatePlayerCommandOfPlayer {
    id: number;
    primaryPositionId: PlayerPositionEnum | undefined;
    height: string | undefined;
    weight: string | undefined;
    dominantHand: string | undefined;
}

export class PlayerStatsVm implements IPlayerStatsVm {
    shots!: ShotStatsVm | undefined;
    swimoffs!: SwimoffStatsVm | undefined;
    turnovers!: TurnoverStatsVm | undefined;
    exclusions!: ExclusionStatsVm | undefined;

    constructor(data?: IPlayerStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shots = _data["shots"] ? ShotStatsVm.fromJS(_data["shots"]) : <any>undefined;
            this.swimoffs = _data["swimoffs"] ? SwimoffStatsVm.fromJS(_data["swimoffs"]) : <any>undefined;
            this.turnovers = _data["turnovers"] ? TurnoverStatsVm.fromJS(_data["turnovers"]) : <any>undefined;
            this.exclusions = _data["exclusions"] ? ExclusionStatsVm.fromJS(_data["exclusions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayerStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shots"] = this.shots ? this.shots.toJSON() : <any>undefined;
        data["swimoffs"] = this.swimoffs ? this.swimoffs.toJSON() : <any>undefined;
        data["turnovers"] = this.turnovers ? this.turnovers.toJSON() : <any>undefined;
        data["exclusions"] = this.exclusions ? this.exclusions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlayerStatsVm {
    shots: ShotStatsVm | undefined;
    swimoffs: SwimoffStatsVm | undefined;
    turnovers: TurnoverStatsVm | undefined;
    exclusions: ExclusionStatsVm | undefined;
}

export class ShotStatsVm implements IShotStatsVm {
    totalShots!: number;
    goalsScored!: number;
    goalsMissed!: number;
    goalsActionScored!: number;
    goalsActionMissed!: number;
    goalsPowerplayScored!: number;
    goalsPowerplayMissed!: number;
    goalsPenaltyScored!: number;
    goalsPenaltyMissed!: number;
    goalsFastBreakScored!: number;
    goalsFastBreakMissed!: number;
    goalsDirectFromFoulScored!: number;
    goalsDirectFromFoulMissed!: number;
    blocked!: number;
    saved!: number;
    assisted!: number;

    constructor(data?: IShotStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalShots = _data["totalShots"];
            this.goalsScored = _data["goalsScored"];
            this.goalsMissed = _data["goalsMissed"];
            this.goalsActionScored = _data["goalsActionScored"];
            this.goalsActionMissed = _data["goalsActionMissed"];
            this.goalsPowerplayScored = _data["goalsPowerplayScored"];
            this.goalsPowerplayMissed = _data["goalsPowerplayMissed"];
            this.goalsPenaltyScored = _data["goalsPenaltyScored"];
            this.goalsPenaltyMissed = _data["goalsPenaltyMissed"];
            this.goalsFastBreakScored = _data["goalsFastBreakScored"];
            this.goalsFastBreakMissed = _data["goalsFastBreakMissed"];
            this.goalsDirectFromFoulScored = _data["goalsDirectFromFoulScored"];
            this.goalsDirectFromFoulMissed = _data["goalsDirectFromFoulMissed"];
            this.blocked = _data["blocked"];
            this.saved = _data["saved"];
            this.assisted = _data["assisted"];
        }
    }

    static fromJS(data: any): ShotStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new ShotStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalShots"] = this.totalShots;
        data["goalsScored"] = this.goalsScored;
        data["goalsMissed"] = this.goalsMissed;
        data["goalsActionScored"] = this.goalsActionScored;
        data["goalsActionMissed"] = this.goalsActionMissed;
        data["goalsPowerplayScored"] = this.goalsPowerplayScored;
        data["goalsPowerplayMissed"] = this.goalsPowerplayMissed;
        data["goalsPenaltyScored"] = this.goalsPenaltyScored;
        data["goalsPenaltyMissed"] = this.goalsPenaltyMissed;
        data["goalsFastBreakScored"] = this.goalsFastBreakScored;
        data["goalsFastBreakMissed"] = this.goalsFastBreakMissed;
        data["goalsDirectFromFoulScored"] = this.goalsDirectFromFoulScored;
        data["goalsDirectFromFoulMissed"] = this.goalsDirectFromFoulMissed;
        data["blocked"] = this.blocked;
        data["saved"] = this.saved;
        data["assisted"] = this.assisted;
        return data;
    }
}

export interface IShotStatsVm {
    totalShots: number;
    goalsScored: number;
    goalsMissed: number;
    goalsActionScored: number;
    goalsActionMissed: number;
    goalsPowerplayScored: number;
    goalsPowerplayMissed: number;
    goalsPenaltyScored: number;
    goalsPenaltyMissed: number;
    goalsFastBreakScored: number;
    goalsFastBreakMissed: number;
    goalsDirectFromFoulScored: number;
    goalsDirectFromFoulMissed: number;
    blocked: number;
    saved: number;
    assisted: number;
}

export class SwimoffStatsVm implements ISwimoffStatsVm {
    totalWins!: number;
    totalLoses!: number;

    constructor(data?: ISwimoffStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalWins = _data["totalWins"];
            this.totalLoses = _data["totalLoses"];
        }
    }

    static fromJS(data: any): SwimoffStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new SwimoffStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWins"] = this.totalWins;
        data["totalLoses"] = this.totalLoses;
        return data;
    }
}

export interface ISwimoffStatsVm {
    totalWins: number;
    totalLoses: number;
}

export class TurnoverStatsVm implements ITurnoverStatsVm {
    totalTurnoversWon!: number;
    totalTurnoversLost!: number;
    lostBallTurnoversWon!: number;
    lostBallTurnoversLost!: number;
    offensiveFoulTurnoversWon!: number;
    offensiveFoulTurnoversLost!: number;
    ballUnderTurnoversWon!: number;
    ballUnderTurnoversLost!: number;
    clockExpiredTurnoversWon!: number;
    clockExpiredTurnoversLost!: number;

    constructor(data?: ITurnoverStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTurnoversWon = _data["totalTurnoversWon"];
            this.totalTurnoversLost = _data["totalTurnoversLost"];
            this.lostBallTurnoversWon = _data["lostBallTurnoversWon"];
            this.lostBallTurnoversLost = _data["lostBallTurnoversLost"];
            this.offensiveFoulTurnoversWon = _data["offensiveFoulTurnoversWon"];
            this.offensiveFoulTurnoversLost = _data["offensiveFoulTurnoversLost"];
            this.ballUnderTurnoversWon = _data["ballUnderTurnoversWon"];
            this.ballUnderTurnoversLost = _data["ballUnderTurnoversLost"];
            this.clockExpiredTurnoversWon = _data["clockExpiredTurnoversWon"];
            this.clockExpiredTurnoversLost = _data["clockExpiredTurnoversLost"];
        }
    }

    static fromJS(data: any): TurnoverStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTurnoversWon"] = this.totalTurnoversWon;
        data["totalTurnoversLost"] = this.totalTurnoversLost;
        data["lostBallTurnoversWon"] = this.lostBallTurnoversWon;
        data["lostBallTurnoversLost"] = this.lostBallTurnoversLost;
        data["offensiveFoulTurnoversWon"] = this.offensiveFoulTurnoversWon;
        data["offensiveFoulTurnoversLost"] = this.offensiveFoulTurnoversLost;
        data["ballUnderTurnoversWon"] = this.ballUnderTurnoversWon;
        data["ballUnderTurnoversLost"] = this.ballUnderTurnoversLost;
        data["clockExpiredTurnoversWon"] = this.clockExpiredTurnoversWon;
        data["clockExpiredTurnoversLost"] = this.clockExpiredTurnoversLost;
        return data;
    }
}

export interface ITurnoverStatsVm {
    totalTurnoversWon: number;
    totalTurnoversLost: number;
    lostBallTurnoversWon: number;
    lostBallTurnoversLost: number;
    offensiveFoulTurnoversWon: number;
    offensiveFoulTurnoversLost: number;
    ballUnderTurnoversWon: number;
    ballUnderTurnoversLost: number;
    clockExpiredTurnoversWon: number;
    clockExpiredTurnoversLost: number;
}

export class ExclusionStatsVm implements IExclusionStatsVm {
    totalExclusions!: number;
    exclusions!: number;
    suspensions!: number;
    brutalities!: number;
    penalties!: number;
    totalExclusionsDrawn!: number;
    exclusionsDrawn!: number;
    suspensionsDrawn!: number;
    brutalitiesDrawn!: number;
    penaltiesDrawn!: number;

    constructor(data?: IExclusionStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalExclusions = _data["totalExclusions"];
            this.exclusions = _data["exclusions"];
            this.suspensions = _data["suspensions"];
            this.brutalities = _data["brutalities"];
            this.penalties = _data["penalties"];
            this.totalExclusionsDrawn = _data["totalExclusionsDrawn"];
            this.exclusionsDrawn = _data["exclusionsDrawn"];
            this.suspensionsDrawn = _data["suspensionsDrawn"];
            this.brutalitiesDrawn = _data["brutalitiesDrawn"];
            this.penaltiesDrawn = _data["penaltiesDrawn"];
        }
    }

    static fromJS(data: any): ExclusionStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new ExclusionStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalExclusions"] = this.totalExclusions;
        data["exclusions"] = this.exclusions;
        data["suspensions"] = this.suspensions;
        data["brutalities"] = this.brutalities;
        data["penalties"] = this.penalties;
        data["totalExclusionsDrawn"] = this.totalExclusionsDrawn;
        data["exclusionsDrawn"] = this.exclusionsDrawn;
        data["suspensionsDrawn"] = this.suspensionsDrawn;
        data["brutalitiesDrawn"] = this.brutalitiesDrawn;
        data["penaltiesDrawn"] = this.penaltiesDrawn;
        return data;
    }
}

export interface IExclusionStatsVm {
    totalExclusions: number;
    exclusions: number;
    suspensions: number;
    brutalities: number;
    penalties: number;
    totalExclusionsDrawn: number;
    exclusionsDrawn: number;
    suspensionsDrawn: number;
    brutalitiesDrawn: number;
    penaltiesDrawn: number;
}

export class MatchMessage implements IMatchMessage {
    messageType!: MatchHubMessageTypeEnum;
    event!: EventVm | undefined;

    constructor(data?: IMatchMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.event = _data["event"] ? EventVm.fromJS(_data["event"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MatchMessage {
        data = typeof data === 'object' ? data : {};
        let result = new MatchMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMatchMessage {
    messageType: MatchHubMessageTypeEnum;
    event: EventVm | undefined;
}

export enum MatchHubMessageTypeEnum {
    CreateEvent = 1300,
    UpdateEvent = 1301,
    DeleteEvent = 1302,
    MatchFinished = 1303,
}

export class UpdateTeamCoachCommandOfTeamCoach extends CreateTeamCoachCommandOfTeamCoach implements IUpdateTeamCoachCommandOfTeamCoach {
    id!: number;

    constructor(data?: IUpdateTeamCoachCommandOfTeamCoach) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTeamCoachCommandOfTeamCoach {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamCoachCommandOfTeamCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTeamCoachCommandOfTeamCoach extends ICreateTeamCoachCommandOfTeamCoach {
    id: number;
}

export class UpdateTeamPlayerCommandOfTeamPlayer extends CreateTeamPlayerCommandOfTeamPlayer implements IUpdateTeamPlayerCommandOfTeamPlayer {
    id!: number;

    constructor(data?: IUpdateTeamPlayerCommandOfTeamPlayer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTeamPlayerCommandOfTeamPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamPlayerCommandOfTeamPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTeamPlayerCommandOfTeamPlayer extends ICreateTeamPlayerCommandOfTeamPlayer {
    id: number;
}

export class PaginatedListOfTeamVm implements IPaginatedListOfTeamVm {
    pageItems!: TeamVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfTeamVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(TeamVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfTeamVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTeamVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfTeamVm {
    pageItems: TeamVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class TeamDetailVm extends TeamVm implements ITeamDetailVm {
    logo!: string | undefined;
    competitionTeams!: CompetitionTeamVm[];
    homeMatches!: MatchVm[];
    awayMatches!: MatchVm[];
    players!: TeamPlayerVm[];
    coaches!: TeamCoachVm[];

    constructor(data?: ITeamDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logo = _data["logo"];
            if (Array.isArray(_data["competitionTeams"])) {
                this.competitionTeams = [] as any;
                for (let item of _data["competitionTeams"])
                    this.competitionTeams!.push(CompetitionTeamVm.fromJS(item));
            }
            if (Array.isArray(_data["homeMatches"])) {
                this.homeMatches = [] as any;
                for (let item of _data["homeMatches"])
                    this.homeMatches!.push(MatchVm.fromJS(item));
            }
            if (Array.isArray(_data["awayMatches"])) {
                this.awayMatches = [] as any;
                for (let item of _data["awayMatches"])
                    this.awayMatches!.push(MatchVm.fromJS(item));
            }
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(TeamPlayerVm.fromJS(item));
            }
            if (Array.isArray(_data["coaches"])) {
                this.coaches = [] as any;
                for (let item of _data["coaches"])
                    this.coaches!.push(TeamCoachVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        if (Array.isArray(this.competitionTeams)) {
            data["competitionTeams"] = [];
            for (let item of this.competitionTeams)
                data["competitionTeams"].push(item.toJSON());
        }
        if (Array.isArray(this.homeMatches)) {
            data["homeMatches"] = [];
            for (let item of this.homeMatches)
                data["homeMatches"].push(item.toJSON());
        }
        if (Array.isArray(this.awayMatches)) {
            data["awayMatches"] = [];
            for (let item of this.awayMatches)
                data["awayMatches"].push(item.toJSON());
        }
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        if (Array.isArray(this.coaches)) {
            data["coaches"] = [];
            for (let item of this.coaches)
                data["coaches"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITeamDetailVm extends ITeamVm {
    logo: string | undefined;
    competitionTeams: CompetitionTeamVm[];
    homeMatches: MatchVm[];
    awayMatches: MatchVm[];
    players: TeamPlayerVm[];
    coaches: TeamCoachVm[];
}

export class TeamMinInfoDto implements ITeamMinInfoDto {
    id!: number;
    name!: string | undefined;
    nameUniversal!: string | undefined;
    shortName!: string | undefined;
    country!: string | undefined;
    city!: string | undefined;
    logo!: string | undefined;

    constructor(data?: ITeamMinInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): TeamMinInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMinInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["country"] = this.country;
        data["city"] = this.city;
        data["logo"] = this.logo;
        return data;
    }
}

export interface ITeamMinInfoDto {
    id: number;
    name: string | undefined;
    nameUniversal: string | undefined;
    shortName: string | undefined;
    country: string | undefined;
    city: string | undefined;
    logo: string | undefined;
}

export class CreateTeamCommandOfTeam implements ICreateTeamCommandOfTeam {
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    venue!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    logo!: string | undefined;
    isPro!: boolean;
    clubId!: number;
    categoryId!: number;
    countryId!: number | undefined;
    cityId!: number | undefined;

    constructor(data?: ICreateTeamCommandOfTeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.logo = _data["logo"];
            this.isPro = _data["isPro"];
            this.clubId = _data["clubId"];
            this.categoryId = _data["categoryId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
        }
    }

    static fromJS(data: any): CreateTeamCommandOfTeam {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamCommandOfTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["logo"] = this.logo;
        data["isPro"] = this.isPro;
        data["clubId"] = this.clubId;
        data["categoryId"] = this.categoryId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        return data;
    }
}

export interface ICreateTeamCommandOfTeam {
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    venue: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    logo: string | undefined;
    isPro: boolean;
    clubId: number;
    categoryId: number;
    countryId: number | undefined;
    cityId: number | undefined;
}

export class UpdateTeamCommandOfTeam extends CreateTeamCommandOfTeam implements IUpdateTeamCommandOfTeam {
    id!: number;

    constructor(data?: IUpdateTeamCommandOfTeam) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTeamCommandOfTeam {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamCommandOfTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTeamCommandOfTeam extends ICreateTeamCommandOfTeam {
    id: number;
}

export class TeamStatsVm implements ITeamStatsVm {
    shots!: ShotStatsVm | undefined;
    swimoffs!: SwimoffStatsVm | undefined;
    turnovers!: TurnoverStatsVm | undefined;
    exclusions!: ExclusionStatsVm | undefined;

    constructor(data?: ITeamStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shots = _data["shots"] ? ShotStatsVm.fromJS(_data["shots"]) : <any>undefined;
            this.swimoffs = _data["swimoffs"] ? SwimoffStatsVm.fromJS(_data["swimoffs"]) : <any>undefined;
            this.turnovers = _data["turnovers"] ? TurnoverStatsVm.fromJS(_data["turnovers"]) : <any>undefined;
            this.exclusions = _data["exclusions"] ? ExclusionStatsVm.fromJS(_data["exclusions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TeamStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shots"] = this.shots ? this.shots.toJSON() : <any>undefined;
        data["swimoffs"] = this.swimoffs ? this.swimoffs.toJSON() : <any>undefined;
        data["turnovers"] = this.turnovers ? this.turnovers.toJSON() : <any>undefined;
        data["exclusions"] = this.exclusions ? this.exclusions.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITeamStatsVm {
    shots: ShotStatsVm | undefined;
    swimoffs: SwimoffStatsVm | undefined;
    turnovers: TurnoverStatsVm | undefined;
    exclusions: ExclusionStatsVm | undefined;
}

export class UserVm implements IUserVm {
    id!: string;
    userName!: string;
    email!: string;
    phoneNumber!: string | undefined;
    federationId!: number | undefined;
    federation!: string | undefined;
    clubId!: number | undefined;
    club!: string | undefined;
    personId!: number | undefined;
    person!: string | undefined;
    emailConfirmed!: boolean;
    typeId!: RoleEnum[] | undefined;
    type!: string[];

    constructor(data?: IUserVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.federationId = _data["federationId"];
            this.federation = _data["federation"];
            this.clubId = _data["clubId"];
            this.club = _data["club"];
            this.personId = _data["personId"];
            this.person = _data["person"];
            this.emailConfirmed = _data["emailConfirmed"];
            if (Array.isArray(_data["typeId"])) {
                this.typeId = [] as any;
                for (let item of _data["typeId"])
                    this.typeId!.push(item);
            }
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(item);
            }
        }
    }

    static fromJS(data: any): UserVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["federationId"] = this.federationId;
        data["federation"] = this.federation;
        data["clubId"] = this.clubId;
        data["club"] = this.club;
        data["personId"] = this.personId;
        data["person"] = this.person;
        data["emailConfirmed"] = this.emailConfirmed;
        if (Array.isArray(this.typeId)) {
            data["typeId"] = [];
            for (let item of this.typeId)
                data["typeId"].push(item);
        }
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item);
        }
        return data;
    }
}

export interface IUserVm {
    id: string;
    userName: string;
    email: string;
    phoneNumber: string | undefined;
    federationId: number | undefined;
    federation: string | undefined;
    clubId: number | undefined;
    club: string | undefined;
    personId: number | undefined;
    person: string | undefined;
    emailConfirmed: boolean;
    typeId: RoleEnum[] | undefined;
    type: string[];
}

export enum RoleEnum {
    Admin = 0,
    Federation = 1,
    Club = 2,
    Person = 3,
}

export class IdentityUserOfString implements IIdentityUserOfString {
    id!: string | undefined;
    userName!: string | undefined;
    normalizedUserName!: string | undefined;
    email!: string | undefined;
    normalizedEmail!: string | undefined;
    emailConfirmed!: boolean;
    passwordHash!: string | undefined;
    securityStamp!: string | undefined;
    concurrencyStamp!: string | undefined;
    phoneNumber!: string | undefined;
    phoneNumberConfirmed!: boolean;
    twoFactorEnabled!: boolean;
    lockoutEnd!: Date | undefined;
    lockoutEnabled!: boolean;
    accessFailedCount!: number;

    constructor(data?: IIdentityUserOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUserOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }
}

export interface IIdentityUserOfString {
    id: string | undefined;
    userName: string | undefined;
    normalizedUserName: string | undefined;
    email: string | undefined;
    normalizedEmail: string | undefined;
    emailConfirmed: boolean;
    passwordHash: string | undefined;
    securityStamp: string | undefined;
    concurrencyStamp: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberConfirmed: boolean;
    twoFactorEnabled: boolean;
    lockoutEnd: Date | undefined;
    lockoutEnabled: boolean;
    accessFailedCount: number;
}

export class IdentityUser extends IdentityUserOfString implements IIdentityUser {

    constructor(data?: IIdentityUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityUser {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityUser extends IIdentityUserOfString {
}

export class ApplicationUser extends IdentityUser implements IApplicationUser {

    constructor(data?: IApplicationUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationUser extends IIdentityUser {
}

export class CreateUserCommand implements ICreateUserCommand {
    email!: string;
    typeId!: RoleEnum;
    federationId!: number;
    clubId!: number;
    personId!: number;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.typeId = _data["typeId"];
            this.federationId = _data["federationId"];
            this.clubId = _data["clubId"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["typeId"] = this.typeId;
        data["federationId"] = this.federationId;
        data["clubId"] = this.clubId;
        data["personId"] = this.personId;
        return data;
    }
}

export interface ICreateUserCommand {
    email: string;
    typeId: RoleEnum;
    federationId: number;
    clubId: number;
    personId: number;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    id!: string;
    typeId!: RoleEnum;
    federationId!: number;
    clubId!: number;
    personId!: number;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.federationId = _data["federationId"];
            this.clubId = _data["clubId"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["federationId"] = this.federationId;
        data["clubId"] = this.clubId;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IUpdateUserCommand {
    id: string;
    typeId: RoleEnum;
    federationId: number;
    clubId: number;
    personId: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

// 2026-03-23: One-time guard used to prevent infinite auth recovery redirects
// when stale tokens/cookies trigger repeated 401 responses after deploy/restart.
const AUTH_RECOVERY_FLAG = 'twa-auth-recovering';